import {
  Box,
  Button,
  Checkbox,
  Divider,
  Flex,
  FormLabel,
  Grid,
  Icon,
  IconButton,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Select,
  SimpleGrid,
  Stack,
  Tab,
  Table,
  TableContainer,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { AsyncSelect, GroupBase, OptionBase } from "chakra-react-select";
import OrderStatus from "components/orderStatus";
import {
  convertData,
  formatarNomeCompleto,
  formatCurrencyFloor,
  getUserProfiles,
  isEmail,
  IsEmpty,
  IsNotEmpty,
  maskCelular,
  maskCep,
  maskCpfCnpj,
  maskDataInfo,
  maskDatainfor,
  maskOnlyNumbers,
  menor12Anos,
  ufSelect,
  IsCPF,
  isAbleToGiveGratuidade,
} from "config/functions";
import { pt } from "date-fns/locale";
import { MdSearch, MdStore } from "react-icons/md";
import InfiniteScroll from "react-infinite-scroll-component";
import Camera from "components/camera/Camera";
import { ClientePessoaFisica } from "views/admin/atendimento/profile/components/Cliente";
import "assets/css/DatePickerInput.css";
import "assets/css/SelectAsync.css";
import Card from "components/card/Card";
import InputField from "components/fields/InputField";
import PopOverAlert from "components/popAlert/popAlert";

import { AuthContext } from "contexts/requiredAuth";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

// Assets
import { CircProgressMini } from "components/charts/CircularProgress";
import TextField from "components/fields/TextField";
import {
  alteraClienteAtendimento2,
  alterarEstudanteNaEscola,
  aprovarGratuidade,
  atualizarRegras,
  buscaCep,
  buscarHistoricoPedidoCartao,
  buscarLojasNaAPI,
  buscarRegrasPorGratuidade,
  cadastraCliente,
  consultaEstudanteGratuidade,
  consultarGratuidadeEstudante,
  editaGratuidade,
  finalizarPedidoCartao,
  getEscolas,
  salvarEstudanteNaEscola,
  pesquisaEstudante,
  pesquisaCliente,
  getOperadoras,
} from "config/apis/requests";
import { DateRangePicker } from "react-date-range";
import { IoCloseCircle, IoSearch } from "react-icons/io5";
import {
  MdCheck,
  MdFlag,
  MdOutlineClear,
  MdOutlineDoubleArrow,
  MdOutlineEngineering,
  MdYoutubeSearchedFor,
} from "react-icons/md";
import { toast } from "react-toastify";
import { isEmpty } from "@chakra-ui/utils";
import { set } from "date-fns";
export default function Estudante() {
  const idTipoGratuidade = 1; // Estudante
  const { push } = useHistory();
  const { logout } = useContext(AuthContext);
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const bgBar = useColorModeValue("secondaryGray.100", "whiteAlpha.100");
  const textColorTertiary = useColorModeValue("secondaryGray.600", "white");
  const textColorSecondary = "secondaryGray.600";
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const [operadora, setOperadora] = useState([]);
  const [idOperadora, setIdOperadora] = useState<number | null>(null); //tirar depois o dois quando tiver usuario com idOperadora
  const [activeBullets, setActiveBullets] = useState({
    form: true,
    media: false,
    rules: false,
    askCard: false,
    validation: false,
  });
  const [modalData, setModalData] = useState(false);
  const iconColor = useColorModeValue("brand.500", "white");
  const formTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const mediaTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const rulesTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const cardTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const validationTab =
    React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const cliente = new ClientePessoaFisica();
  const [hasMore, setHasMore] = useState(false);
  const [pagina, setPagina] = useState(1);
  const [showForm, setShowForm] = useState(false);
  const [showErro, setShowErro] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isCancelOpen, setIsCancelOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [titlePopOver, setTitlePopOver] = useState("Ops...");
  const [subtitlePopOver, setSubtitlePopOver] = useState("");
  const [statusPopOver, setStatusPopOver] = useState("warning");
  const [idGratuidade, setIdGratuidade] = useState(0);

  const [gratuidadeCancelada, setGratuidadeCancelada] = useState(false);
  const [temGratuidade, setTemGratuidade] = useState(false);
  const [dataCadastroUser, setDataCadastroUser] = useState("");
  const [viewElements, setViewElements] = useState(false);
  const [usuariosPesquisa, setUsuariosPesquisa] = useState([]);
  const [listaDeLojas, setListaDeLojas] = useState([]);
  const [lojaSelecionada, setLojaSelecionada] = useState(null);
  const [tipoPedidoCartao, setTipoPedidoCartao] = useState("");
  // ----------------   data form
  const [naoAlterarEstudante, setNaoAlterarEstudante] = useState(false);
  const [cdCliente, setCdCliente] = useState(0);
  const [nomeCompleto, setNomeCompleto] = useState("");
  const [nomeSocial, setNomeSocial] = useState("");
  const dataNascimento = "";
  const [email, setEmail] = useState("");
  const [nomeMae, setNomeMae] = useState("");
  const [sexo, setSexo] = useState("M");
  const [cpfSearch, setCpfSearch] = useState("");
  const [celular, setCelular] = useState("");
  const [image, setImage] = useState("");
  const [logradouro, setLogradouro] = useState("");
  const [cep, setCep] = useState("");
  const [numero, setNumero] = useState("");
  const [pontoReferencia, setPontoReferencia] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [estado, setEstado] = useState("");
  const [checkForm, setCheckForm] = useState(false);
  const [alterarBiometria, setAlterarBiometria] = useState(false);
  const recoverLoggedUser = [JSON.parse(localStorage.getItem("user"))];
  const [matricula, setMatricula] = useState("");
  const [matriculaBd, setMatriculaBd] = useState("");
  const [erroEstudanteDuplicado, setErroEstudanteDuplicado] = useState("");
  const [ondeReceber, setOndeReceber] = useState("loja");
  const [codigoLojaSelecionada, setCodigoLojaSelecionada] = useState(0);

  // ----------------   data rules
  const [escolas, setEscolas] = useState([]);
  const [escolaSelecionada, setEscolaSelecionada] = useState([]);
  const [biometria, setBiometria] = useState(false);
  const [solicitarPedido, setSolicitarPedido] = useState(false);
  const [dataRec, setDataRec] = useState("");
  const [nomeUsuario, setNomeUsuario] = useState("");
  const continuarChamado = false;
  const [novoChamado, setNovoChamado] = useState(false);
  const [protocoloId, setProtocoloId] = useState(0);
  // ----------------   data validations
  const [historicoStatus, setHistoricoStatus] = useState([]);
  const [existePedido, setExistePedido] = useState(false);

  //--------------ZENDESK------------------------

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [protocolo, setProtocolo] = useState([]);
  const [uf, setUF] = useState("");
  const [ticketGerado, setTicketGerado] = useState("");
  const [nrSeqEndereco, setNrSeqEndereco] = useState(0);
  const [observacaoChamado, setObservacaoChamado] = useState("");
  const [dataUser, setDataUser] = useState<any>(null);
  const [restricao, setRestricao] = useState(false);
  const [loadingCep, setLoadingCep] = useState(false);

  const perfisPermitidosBiometria = [
    "ADMINISTRADOR",
    "ATENDENTE_LOJA",
    "SUPERVISOR_LOJA",
    "CADASTRO_ESTUDANTE",
  ];
  let dataLogin: any = [];
  let dataLoginEstudante: any = [];

  const montaList: any[] = [];
  const dataRegras: any[] = [];
  //--------------ZENDESK------------------------^^

  interface PerfisUsuario {
    perfis: string[];
  }

  const usuarios: PerfisUsuario[] = [
    {
      perfis: recoverLoggedUser[0]?.perfis,
    },
  ];

  const perfisDesejadosDataNascimento = ["ADMINISTRADOR", "SUPERVISOR_LOJA"];
  const perfisDesejados = [
    "ADMINISTRADOR",
    "SUPERVISOR_ESTUDANTE",
    "SUPERVISOR_LOJA",
    "ATENDENTE_LOJA",
    "CADASTRO_ESTUDANTE",
  ];

  const perfisCadastro = [
    "ADMINISTRADOR",
    "SUPERVISOR_ESTUDANTE",
    "SUPERVISOR_LOJA",
    "CADASTRO_ESTUDANTE",
  ];

  interface EscolasOption extends OptionBase {
    label: string;
    value: string;
    colorScheme: string;
  }

  const algumUsuarioCompativel = usuarios?.some((usuario) => {
    return usuario.perfis?.some((perfil) =>
      perfisPermitidosBiometria.includes(perfil),
    );
  });

  const onChangeModalDataClose = () => {
    //document.getElementById("fotoElementoUsuario").style.display = "block";
    //document.getElementById("fotoElementoUsuario2").style.display = "block";
    setModalData(!modalData);
  };

  const handleFocusChange = async (cepChange: any) => {
    setLoadingCep(true);
    const { estado, cidade, bairro, logradouro, restricao } =
      await buscaCep(cepChange);
    setLoadingCep(false);

    if (restricao === 1) {
      setRestricao(true);
    } else {
      setRestricao(false);
    }

    if (cepChange && !cepChange.includes(".")) {
      setUF(estado);
      setBairro(bairro);
      setCidade(cidade);
      setEstado(estado);
      setLogradouro(logradouro);

      setUF(estado);
    } else {
      setCep(cepChange);
      setUF("");
      setBairro("");
      setCidade("");
      setEstado("");
      setLogradouro("");
    }
  };

  const handleFoto = (foto: any) => {
    if (foto !== "") {
      setImage(foto.replace("data:image/jpeg;base64,", ""));
    }
  };

  const confirmarAtendimento = async (row: any) => {
    setDataUser([]);
    setNovoChamado(true);
    //pesquisa
    if (!IsEmpty(row)) {
      if (row?.codigo) {
        if (row?.celular) {
          setCdCliente(row?.codigo || row?.cdCliente);
          setCelular(row?.celular);
          setImage(row?.base64Imagem);
        }
        setCdCliente(row?.codigo || row?.cdCliente);
        setEmail(row?.email);
        temStatusGratuidade(row?.codigo);
      } else {
        if (
          IsEmpty(dataLoginEstudante) &&
          usuarios[0]?.perfis.some((perfil: string) =>
            perfisCadastro.includes(perfil),
          )
        ) {
          dataLogin = await pesquisaCliente({
            email: null,
            nome: nomeUsuario ? nomeUsuario.toUpperCase() : "",
            numeroDocumento:
              cpfSearch !== undefined ||
              (cpfSearch != "" && cpfSearch.replace(/[^\d]+/g, "")) ||
              matricula !== undefined ||
              (matricula != "" && matricula.replace(/[^\d]+/g, "")) ||
              matriculaBd !== undefined ||
              (matriculaBd != "" && matriculaBd.replace(/[^\d]+/g, "")) ||
              row?.numeroMatricula,
            tipoBusca: "TODOS",
            tipoPessoa: "F",
            pagina: 1,
            quantidadePorPaginacao: 10,
          });

          if (!IsEmpty(dataLogin)) {
            setDataUser(dataLogin);
            setCdCliente(dataLogin[0]?.codigo || dataLogin[0]?.cdCliente);
            if (dataLogin[0]?.tipoDocumento?.codigo == 1) {
              setCpfSearch(dataLogin[0]?.numeroDocumento);
              setMatricula(dataLogin[0]?.numeroDocumentoAlternativo);
              setMatriculaBd(dataLogin[0]?.numeroDocumentoAlternativo);
            } else {
              setCpfSearch(dataLogin[0]?.numeroDocumentoAlternativo);
            }
            setIdOperadora(2); //todo  apagar depois
            setNomeMae(dataLogin[0]?.nomeMae);
            setEmail(dataLogin[0]?.email);
            setUsuariosPesquisa(dataLogin);
            if (dataLogin[0]?.telefone) {
              setCelular(maskCelular(dataLogin[0]?.telefone));
            }
            if (
              IsNotEmpty(dataLogin[0]?.enderecos) &&
              dataLogin[0]?.enderecos != undefined
            ) {
              setNrSeqEndereco(dataLogin[0]?.enderecos[0]?.nrSeqEndereco);
              setCep(maskCep(dataLogin[0]?.enderecos[0]?.cep));
              handleFocusChange(dataLogin[0]?.enderecos[0]?.cep);
              setLogradouro(dataLogin[0]?.enderecos[0]?.logradouro);
              setUF(dataLogin[0]?.enderecos[0]?.uf);
              setBairro(dataLogin[0]?.enderecos[0]?.bairro);
              setNumero(dataLogin[0]?.enderecos[0]?.numero);
              setCidade(dataLogin[0]?.enderecos[0]?.cidade);
              setEstado(dataLogin[0]?.enderecos[0]?.uf);
              setPontoReferencia(dataLogin[0]?.enderecos[0]?.complemento);
            }
          }
        }
      }
      buscaDadosPedidoCartao(row.codigo);

      const bodyConsultaEstudante = {
        numeroMatricula:
          row.numeroMatricula || matricula || matriculaBd || null,
        cdCliente: row.codigo || cdCliente || null,
        cpf: row.numeroDocumento || cpfSearch || null,
      };
      consultaEstudanteGratuidade(bodyConsultaEstudante).then(
        function (result) {
          if (IsEmpty(result?.mensagem) && result !== 400 && result !== 500) {
            const escolaselec = escolas.find(
              (esc) =>
                esc.value == String(result[0]?.codigoEscola).replace(/\s/g, ""),
            );
            setEscolaSelecionada(escolaselec);
          } else if (result === 403) {
            logout();
          }
        },
      );

      if (row.numeroMatricula) {
        setMatricula(row.numeroMatricula);
        setMatriculaBd(row.numeroMatricula);
      } else {
        if (row.tipoDocumento?.codigo === 1) {
          setCpfSearch(row.numeroDocumento);
          setMatriculaBd(row.numeroDocumentoAlternativo);
          setMatricula(row.numeroDocumentoAlternativo);
        } else {
          setMatriculaBd(row.numeroDocumento);
          setMatricula(row.numeroDocumento);
        }
      }
      if (IsEmpty(dataUser)) {
        setDataUser(row);
      }

      setLoading(false);
      setViewElements(true);
      onOpen();
      onClose();
      setShowForm(true);

      //----ZENDESK--------------------
      setCheckForm(true);
      setDataCadastroUser(row.dataCadastro || row.dataInclusao);
      setNomeCompleto(row.nome);

      setDataRec(
        IsNotEmpty(row.dataNascimento)
          ? maskDataInfo(row.dataNascimento + "T00:00:00")
          : "",
      );

      if (row) {
        setNomeSocial(row.nomeSocial);
        setNomeMae(row.nomeMae);
        setEmail(row.email);
        setSexo(row.sexo);
        if (row.telefone) {
          setCelular(maskCelular(row.telefone));
        }
        if (IsNotEmpty(row?.enderecos) && row?.enderecos != undefined) {
          setNrSeqEndereco(row.enderecos[0]?.nrSeqEndereco);
          setCep(maskCep(row.enderecos[0]?.cep));
          handleFocusChange(row.enderecos[0]?.cep);
          setLogradouro(row.enderecos[0]?.logradouro);
          setUF(row.enderecos[0]?.uf);
          setBairro(row.enderecos[0]?.bairro);
          setNumero(row.enderecos[0]?.numero);
          setCidade(row.enderecos[0]?.cidade);
          setEstado(row.enderecos[0]?.uf);
          setPontoReferencia(row.enderecos[0]?.complemento);
        }

        //media

        setImage(
          row.base64Imagem
            ? "data:image/jpeg;base64," + row.base64Imagem.replace('"', "")
            : "",
        );
      }
    } else if (IsEmpty(row)) {
      setLoading(false);
      setViewElements(true);

      onClose();
      setShowForm(true);
    } else {
      handleOpenAlert(true);
    }

    // if ((novoChamado && !IsEmpty(dataUser)) || !IsEmpty(row)) {
    //   cadastrarProtocolo(row, "Inicio atendimento gratuidade estudante ").then(
    //     function (result) {
    //       if (result.id) {
    //         setProtocolo(result.id);
    //         setProtocoloId(result.id);
    //       }
    //     }
    //   );
    // } else if (continuarChamado) {
    //   setProtocolo([]);
    // }
  };

  const finalizarAtendimento = () => {
    showPopOver("success", "Atendimento", "Atendimento encerrado com sucesso!");
    setTimeout(() => {
      window.scrollTo(0, 0);
      window.location.href = "/atendimento#/admin/dashboard";
    }, 2000);
  };
  // ZENDESK ---------------------------------^^

  const showPopOver = (status: string, title: string, subtitle: string) => {
    handleOpenAlert(true);
    setStatusPopOver(status);
    setTitlePopOver(title);
    setSubtitlePopOver(subtitle);
  };

  useEffect(() => {
    const fetchOperadoras = async () => {
      const operadorasResponse = await getOperadoras();
      if (
        !isEmpty(operadorasResponse) &&
        operadorasResponse !== 500 &&
        operadorasResponse !== 400 &&
        operadorasResponse !== 404
      ) {
        localStorage.setItem("operadoras", JSON.stringify(operadorasResponse));
        setOperadora(operadorasResponse);
      }
    };
    if (localStorage.getItem("operadoras") === null) {
      fetchOperadoras();
    } else {
      setOperadora(JSON.parse(localStorage.getItem("operadoras")));
    }
  }, []);

  useEffect(() => {
    // 1. Criamos uma função interna assíncrona
    const buscarDadosEstudante = async () => {
      // Verificação de condições inicial
      const podeBuscar =
        (!IsEmpty(dataUser) && !IsEmpty(cpfSearch) && !IsEmpty(nomeCompleto)) ||
        (!IsEmpty(matriculaBd) && !IsEmpty(matricula));

      if (podeBuscar) {
        const firstUser = Array.isArray(dataUser) ? dataUser[0] : dataUser;
        setCdCliente(firstUser?.cdCliente || firstUser?.codigo || 0);

        try {
          const bodyConsultaEstudante = {
            numeroMatricula: matricula || matriculaBd || null,
            cdCliente: cdCliente || null,
            cpf: cpfSearch || null,
          };
          const result = await consultaEstudanteGratuidade(
            bodyConsultaEstudante,
          );

          if (IsEmpty(result?.mensagem) && result !== 400 && result !== 500 && result !== 403) {
            const escolaselec = escolas.find(
              (esc) =>
                esc.value == String(result[0]?.codigoEscola).replace(/\s/g, ""),
            );

            if (result[0]?.estudanteImportacao?.telefone) {
              setCelular(maskCelular(result[0]?.estudanteImportacao?.telefone));
            }
            if (result[0]?.nomeMae) {
              setNomeMae(result[0]?.nomeMae);
            }
            if (
              result[0]?.numeroMatricula &&
              matricula === "" &&
              matriculaBd === ""
            ) {
              setMatricula(result[0]?.numeroMatricula);
              setMatriculaBd(result[0]?.numeroMatricula);
            }

            setEmail(result[0]?.email);
            setEscolaSelecionada(escolaselec);
          } else if (result === 403) {
            logout();
          } else if (!IsEmpty(result?.mensagem) && result?.status !== 404) {
            showPopOver(
              "error",
              "Estudante",
              result?.mensagem +
              " Contate o administrador passando os dados do cliente!",
            );
            setErroEstudanteDuplicado("Estudante está duplicado na base!");
          }
        } catch (error) {
          console.error("Erro na busca do estudante:", error);
        }
      }
    };

    buscarDadosEstudante();
  }, [dataUser]);

  const handleGetGratuidade = async (
    idCliente: any,
    cpf: any,
    idStatus: any,
    status: string,
    descricao: string,
    acao: string,
    loginAtendimento: any,
  ) => {
    montaList.push({
      tipoRegraGratuidade: 13,
      valor: biometria || menor12Anos(dataRec) ? true : false,
    });
    montaList.push({ tipoRegraGratuidade: 4, valor: "76" });
    let retornoGratuidade = [];
    if (acao === "post") {
      retornoGratuidade = await aprovarGratuidade({
        cdCliente: idCliente,
        cpf: cpf || cpfSearch,
        descricao: "UI_ATENDIMENTO",
        tipoGratuidade: {
          id: idTipoGratuidade,
          descricao: "Estudante",
        },
        statusGratuidade: {
          id: 3,
          descricao: "Aprovado",
        },
        loginAtendente: loginAtendimento,
        regraGratuidadeList: montaList,
      });

      //await salvaRegras(retornoGratuidade?.entidadeRetorno.id, montaList);
      setTemGratuidade(true);
    } else {
      retornoGratuidade = await editaGratuidade({
        id: idGratuidade,
        cpf: cpf || cpfSearch,
        descricao: "UI_ATENDIMENTO",
        tipoGratuidade: {
          id: idTipoGratuidade,
          descricao: descricao,
        },
        statusGratuidade: {
          id: idStatus,
          descricao: status,
        },
        loginAtendente: loginAtendimento,
        regraGratuidadeList: montaList,
      });
    }

    setIdGratuidade(retornoGratuidade?.entidadeRetorno.id);
    setHistoricoStatus(
      retornoGratuidade?.entidadeRetorno.historicoStatusGratuidadeList,
    );
  };

  const temStatusGratuidade = async (codigo: any) => {
    consultarGratuidadeEstudante(codigo).then(function (result) {
      if (
        result[0]?.statusGratuidade?.id == 4 ||
        result[0]?.statusGratuidade?.id == 5 ||
        result[0]?.statusGratuidade?.id == 6 ||
        result[0]?.statusGratuidade?.id == 8
      ) {
        setGratuidadeCancelada(true);
        showPopOver("error", "Gratuidade", "Usuário com gratuidade cancelada!");
      }

      const registroMaisAtual = result.reduce(
        (registroMaisRecente: any, registroAtual: any) => {
          const dataMaisRecente = new Date(registroMaisRecente.dataInclusao);
          const dataAtual = new Date(registroAtual.dataInclusao);

          return dataAtual > dataMaisRecente
            ? registroAtual
            : registroMaisRecente;
        },
        result[0],
      );
      if (typeof registroMaisAtual === "object" && registroMaisAtual?.id) {
        setIdGratuidade(registroMaisAtual?.id);
        setHistoricoStatus(registroMaisAtual.historicoStatusGratuidadeList);

        //setBiometria(item.valor.toString() === "true" ? true : false);
        if (
          registroMaisAtual?.statusGratuidade?.id !== 3 ||
          registroMaisAtual?.tipoGratuidade.id !== 1
        ) {
          setTemGratuidade(false);
          setHistoricoStatus(
            registroMaisAtual?.historicoStatusGratuidadeList,
          );
        } else {
          fetchIdGratuidade(registroMaisAtual?.id);

          setIdGratuidade(registroMaisAtual?.id);
          setHistoricoStatus(
            registroMaisAtual?.historicoStatusGratuidadeList,
          );

          setTemGratuidade(true);
        }
      }
    });
  };

  const fetchIdGratuidade = async (idGratuidadeAtual: any) => {
    buscarRegrasPorGratuidade(idGratuidadeAtual).then(function (result) {
      if (result && result.length > 0) {
        result.forEach((item: any) => {
          if (item.tipoRegraGratuidade.id === 13) {
            if (item.valor.toString() === "false") {
              setBiometria(false);
            } else {
              setBiometria(true);
            }
          }
        });
      }
    });
  };

  const cancelarGratuidade = async () => {
    setLoading(true);
    const codigoUsuario: any[] = [dataUser];
    const temgratuidadeCliente: any[] = [
      await consultarGratuidadeEstudante(codigoUsuario[0]?.codigo),
    ];
    if (typeof temgratuidadeCliente === "object") {
      const objetoMaisRecente = temgratuidadeCliente.reduce(
        (maisRecente: any, item: any) => {
          if (item instanceof Array) {
            item.forEach((subItem) => {
              if (!maisRecente || subItem.id > maisRecente.id) {
                maisRecente = subItem;
              }
            });
          } else {
            if (!maisRecente || item.id > maisRecente.id) {
              maisRecente = item;
            }
          }
          return maisRecente;
        },
        null, // Inicia com null para garantir que o primeiro item seja comparado corretamente
      );

      if (objetoMaisRecente?.statusGratuidade?.id === 3) {
        handleGetGratuidade(
          codigoUsuario[0]?.codigo,
          cpfSearch,
          5,
          "Cancelado",
          "Cancelado UI-ATENDIMENTO",
          "put",
          recoverLoggedUser[0]?.login,
        );
        showPopOver("success", "Gratuidade", "Cancelado!");
      } else {
        showPopOver("error", "Gratuidade", "Erro ao cancelar!");
      }

      setLoading(false);
    }
  };

  const onClickPesquisar = async () => {
    setLoading(true);
    setUsuariosPesquisa([]);
    setDataUser([]);

    const bodyConsultaEstudante = {
      numeroMatricula: matricula || matriculaBd || null,
      cpf: null as string | null,
      cdCliente: null as number | null,
    };
    //

    if (nomeUsuario || cpfSearch || matricula || matriculaBd) {
      if (cpfSearch && !IsCPF(cpfSearch)) {
        showPopOver("error", "Ops...", "Cpf inválido!");
        setLoading(false);
        return;
      }
      dataLoginEstudante = await pesquisaEstudante({
        email: "",
        nome: nomeUsuario || "",
        numeroDocumento:
          cpfSearch?.replace(/[^\d]+/g, "") ||
          matricula?.replace(/[^\d]+/g, "") ||
          matriculaBd?.replace(/[^\d]+/g, "") ||
          "",
        tipoBusca: "TODOS",
        tipoPessoa: "F",
        pagina: 1,
        quantidadePorPaginacao: 10,
      });
      if (
        !IsEmpty(dataLoginEstudante) &&
        dataLoginEstudante !== 404 &&
        dataLoginEstudante !== 400 &&
        dataLoginEstudante !== 500 &&
        dataLoginEstudante !== 403
      ) {
        setUsuariosPesquisa(dataLoginEstudante);
        setEscolaSelecionada(dataLoginEstudante?.codigoEscola);
        setMatricula(dataLoginEstudante.matricula);
        setNomeMae(dataLoginEstudante?.nomeMae);
      } else if (dataLoginEstudante === 403) {
        showPopOver("error", "Ops...", "Sessão expirada!");
        logout();
      }
      dataLogin = await pesquisaCliente({
        email: null,
        nome: nomeUsuario.toUpperCase() || "",
        numeroDocumento:
          cpfSearch?.replace(/[^\d]+/g, "") ||
          matricula?.replace(/[^\d]+/g, "") ||
          matriculaBd?.replace(/[^\d]+/g, ""),
        tipoBusca: "TODOS",
        tipoPessoa: "F",
        pagina: 1,
        quantidadePorPaginacao: 10,
      });
      if (!IsEmpty(dataLogin)) {
        setUsuariosPesquisa(dataLogin);
      }

      if (
        (IsEmpty(dataLogin) && IsEmpty(dataLoginEstudante)) ||
        dataLoginEstudante === 404 ||
        dataLogin === 400
      ) {
        if (
          usuarios[0]?.perfis?.some((perfil: string) =>
            perfisCadastro?.includes(perfil),
          )
        ) {
          onOpen();
        } else if (
          !usuarios[0]?.perfis?.some((perfil: string) =>
            perfisCadastro?.includes(perfil),
          )
        ) {
          showPopOver(
            "error",
            "Ops...",
            "Perfil não autorizado a dar gratuidade!",
          );
        } else if (
          (dataLoginEstudante === 500 && dataLogin === 500) ||
          (dataLoginEstudante === 400 && dataLogin === 400)
        ) {
          showPopOver("error", "Ops...3", "Erro ao buscar estudante!");
        }

        setLoading(false);
        return;
      } else {
        if (dataLogin === 403 || dataLoginEstudante === 403) {
          logout();
        } else if (
          dataLogin === 400 ||
          dataLogin === 404 ||
          dataLogin === 500 ||
          dataLoginEstudante === 400 ||
          dataLoginEstudante === 404 ||
          dataLoginEstudante === 500
        ) {
          // handleOpenAlert(true);
          setLoading(false);
        } else {
          if (!IsEmpty(dataLogin) || !IsEmpty(dataLoginEstudante)) {
            if (dataLogin.length < 5 || dataLoginEstudante.length < 5) {
              setHasMore(false);
            } else {
              setHasMore(true);
              setPagina(2);
            }
            setViewElements(false);
            setLoading(false);
          } else {
            //Busca nova tabela estudante
            const bodyConsultaEstudante = {
              numeroMatricula: matricula || matriculaBd || null,
              cdCliente: cdCliente || null,
              cpf: cpfSearch || null,
            };
            dataLoginEstudante = await consultaEstudanteGratuidade(
              bodyConsultaEstudante,
            );

            if (dataLoginEstudante === 403 || dataLoginEstudante === 401) {
              logout();
            } else if (
              dataLoginEstudante === 400 ||
              dataLoginEstudante === 404 ||
              dataLoginEstudante === 500
            ) {
              if (
                usuarios[0]?.perfis.some((perfil: string) =>
                  perfisDesejados.includes(perfil),
                ) &&
                nomeUsuario === ""
              ) {
                onOpen();
              } else {
                showPopOver("error", "Ops...", "Aluno não encontrado!");
              }
              setLoading(false);
            } else {
              if (dataLoginEstudante !== "Estudante não encontrado!") {
                if (dataLoginEstudante.length < 5) {
                  setHasMore(false);
                } else {
                  setHasMore(true);
                  setPagina(2);
                }
                setViewElements(false);
                setUsuariosPesquisa([dataLoginEstudante]);
                setLoading(false);
              }
            }

            if (
              dataLoginEstudante === "Estudante não encontrado!" &&
              IsEmpty(dataLogin)
            ) {
              setUsuariosPesquisa([]);
              setViewElements(false);

              if (
                usuarios[0]?.perfis.some((perfil: string) =>
                  perfisDesejados.includes(perfil),
                ) &&
                nomeUsuario === ""
              ) {
                onOpen();
              } else {
                showPopOver(
                  "error",
                  "Ops...",
                  "Perfil não autorizado a cadastrar novo aluno!",
                );
              }
            }

            setLoading(false);
          }
        }
      }
      setLoading(false);
    } else {
      showPopOver(
        "error",
        "Ops...",
        "Preencha ao menos 1 campo para pesquisa!",
      );
      setLoading(false);
    }
  };

  const handleKeyDown = (e: { key: string }) => {
    if (e.key === "Enter") {
      onClickPesquisar();
    }
  };

  const cleanFields = () => {
    setLoading(false);
    setCheckForm(false);
    setIdGratuidade(0);
    setTemGratuidade(false);
    setMatricula("");
    setEscolaSelecionada([]);
    setLojaSelecionada(null);
    setErroEstudanteDuplicado("");
    setIdOperadora(null);

    //form
    setDataCadastroUser("");
    setCdCliente(0);
    setNomeCompleto("");
    setNomeSocial("");
    setDataRec("");
    setEmail("");
    setSexo("M");
    setCelular("");
    setCep("");
    setUF("");
    setLogradouro("");
    setBairro("");
    setNumero("");
    setCidade("");
    setEstado("");
    setPontoReferencia("");
    setImage("");

    // UPLOADS FILES
    setBiometria(false);
    setHistoricoStatus([]);
    setActiveBullets({
      form: true,
      media: false,
      rules: false,
      askCard: false,
      validation: false,
    });
  };
  const handleSelect = (ranges: any) => {
    setSelectedDateRange(ranges.selection);
  };
  const handleOpenAlert = (
    status: boolean | ((prevState: boolean) => boolean),
  ) => {
    setIsOpen2(status);
  };
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const handleChangeMask = (event: { target: { value: any } }) => {
    const { value } = event.target;
    if (value.length < 15) {
      const valueRet = maskCpfCnpj(value);
      setCpfSearch(valueRet);
    }
  };

  const handleValorMatricula = (event: { target: { value: any } }) => {
    const { value } = event.target;
    setMatricula(value);
  };

  const validateForm = async () => {
    const erros = [];

    if (IsEmpty(nomeCompleto) && IsEmpty(nomeUsuario)) {
      erros.push("Nome completo deve ser preenchido!");
    }

    const matriculaLimpa = matricula.replace(/[^\d]+/g, "");
    const bodyConsultaEstudante = {
      numeroMatricula: matricula || matriculaBd || null,
      cpf: null as string | null,
      cdCliente: null as number | null,
    };
    //
    const existeEstudanteMatricula = await consultaEstudanteGratuidade(
      bodyConsultaEstudante,
    );

    if (IsEmpty(escolaSelecionada) || escolaSelecionada === undefined) {
      erros.push("Escola deve ser preenchida!");
    }

    // if (
    //   existeEstudanteMatricula[0]?.numeroMatricula &&
    //   existeEstudanteMatricula[0]?.codigo !== cdCliente &&
    //   existeEstudanteMatricula[0]?.cdCliente !== cdCliente
    // ) {
    //   erros.push("Matrícula já cadastrada para outro estudante!");
    // }
    if (matricula.length < 5) {
      erros.push("Matrícula deve ter no mínimo 5 caracteres!");
    } else if (/^0+$/.test(matriculaLimpa)) {
      // O regex /^0+$/ verifica se a string contém APENAS o caractere '0' do início ao fim
      erros.push("A matrícula não pode ser composta apenas por zeros!");
    }

    if (IsEmpty(matricula)) {
      erros.push("Matricula deve ser preenchida!");
    }

    if (!IsEmpty(email)) {
      // erros.push("Email deve ser preenchido!");

      if (!isEmail(email)) {
        erros.push("Preencha com um email válido!");
      }
    }

    if (IsEmpty(dataRec)) {
      erros.push("Data de nascimento deve ser válida!");
    }

    if (IsEmpty(celular)) {
      erros.push("Celular deve ser preenchido!");
    }

    if (IsEmpty(erros)) {
      return true;
    } else {
      erros.map((e: any) => {
        showPopOver("error", "Ops...", e);
        return false;
      });
    }
    setLoading(false);
  };

  const buscaDadosPedidoCartao = (id: any) => {
    if (id) {
      buscarHistoricoPedidoCartao(id, "3").then(function (result: any) {
        if (result !== 400 || result !== 500) {
          if (result?.temPedidoCartaoPrimeiraVia === true) {
            setExistePedido(true);
          }

          if (result?.temPedidoCartaoSegundaVia === true) {
            setExistePedido(true);
          }

          if (
            result?.tipoPedido === "1 VIA SOLICITADA" ||
            result?.tipoPedido === "2 VIA SOLICITADA"
          ) {
            setExistePedido(true);
          } else if (result?.tipoPedido === "PODE SOLICITAR PRIMEIRA_VIA") {
            setExistePedido(false);
          } else if (result?.tipoPedido === "PODE SOLICITAR SEGUNDA_VIA") {
            setExistePedido(false);
            setTipoPedidoCartao(result?.tipoPedido);
          } else if (result.tipoPedido === "EXISTE") {
            setExistePedido(true);
          }
        }
      });
    }
  };

  useEffect(() => {
    //window.scrollTo(0, 0);

    const fetchDataEscolas = async () => {
      const dataEscolas = await getEscolas();
      if (IsNotEmpty(dataEscolas)) {
        const valE = dataEscolas.map(
          (v: { codigoEscola: any; descricao: any }) => {
            return {
              value: v.codigoEscola,
              label: v.descricao,
              colorScheme: "red",
            };
          },
        );
        localStorage.setItem("escolas", JSON.stringify(dataEscolas));
        setEscolas(valE);
      } else {
        setShowErro(true);
        setShowForm(false);
        //popOver
        showPopOver(
          "error",
          "Ops...",
          "Erro ao buscar escolas, contate o administrador!",
        );
        setTimeout(() => {
          logout();
          push("/auth/sign-in");
        }, 2000);
      }
    };
    if (localStorage.getItem("escolas") !== null) {
      const dataEscolas = JSON.parse(localStorage.getItem("escolas") || "[]");
      const valE = dataEscolas.map(
        (v: { codigoEscola: any; descricao: any }) => {
          return {
            value: v.codigoEscola,
            label: v.descricao,
            colorScheme: "red",
          };
        },
      );
      setEscolas(valE);
    } else {
      fetchDataEscolas();
    }

    if (idGratuidade > 0 && dataRegras.length > 0) {
      if (!temGratuidade) {
        fetchIdGratuidade(idGratuidade);
      }
    }
  }, []);
  type Endereco = {
    nrSeqEndereco: number;
    logradouro: string;
    complemento: string;
    bairro: string;
    cidade: string;
    uf: string;
    cep: string;
    numero: string;
    dataInativacao: string | null;
  };

  function obterEnderecoMaisRecente(enderecos: Endereco[]): Endereco {
    if (enderecos?.length === 0) return;
    return enderecos?.reduce((prev, curr) =>
      prev?.nrSeqEndereco > curr?.nrSeqEndereco ? prev : curr,
    );
  }
  function obterEnderecosMaisRecentes(lojas: any) {
    if (!lojas || lojas.length === 0) {
      return null;
    }
    return lojas.map((loja: any) => {
      const enderecoMaisRecente = obterEnderecoMaisRecente(loja.enderecos);
      return {
        ...loja,
        enderecos: [enderecoMaisRecente],
      };
    });
  }

  const canCreateStudant = () => {
    const perfis = getUserProfiles();

    return (
      perfis.includes("ADMINISTRADOR") ||
      perfis.includes("SUPERVISOR_ESTUDANTE") ||
      perfis.includes("ATENDENTE_LOJA") ||
      perfis.includes("CADASTRO_ESTUDANTE") ||
      perfis.includes("SUPERVISOR_LOJA") ||
      perfis.includes("ATENDIMENTO_GRATUIDADE_CONCESSAO")
    );
  };

  const hasFullPermission = () => {
    const perfis = getUserProfiles();

    return (
      perfis.includes("ADMINISTRADOR") ||
      perfis.includes("SUPERVISOR_ESTUDANTE") ||
      perfis.includes("CADASTRO_ESTUDANTE") ||
      perfis.includes("SUPERVISOR_LOJA") ||
      perfis.includes("ATENDENTE_LOJA") ||
      perfis.includes("ATENDIMENTO_GRATUIDADE_CONCESSAO")
    );
  };
  const handleLogout = () => {
    logout();
    push("/auth/sign-in");
  };

  useEffect(() => {
    if (listaDeLojas.length > 0) {
      setListaDeLojas(
        obterEnderecosMaisRecentes(JSON.parse(localStorage.getItem("lojas"))),
      );
    } else {
      const fetchLojas = async () => {
        const res = await buscarLojasNaAPI();
        if (typeof res !== "undefined" && Array.isArray(res)) {
          localStorage.setItem("lojas", JSON.stringify(res));
          setListaDeLojas(res);
          setLojaSelecionada(res[0].codigo);
        } else if (res === 403) {
          setTimeout(() => {
            showPopOver("error", "Ops..", "Sessão expirada, logue novamente!");
          }, 3000);
          handleLogout();
        } else {
          showPopOver(
            "error",
            "Lojas",
            "Erro ao buscar lojas, contate o administrador!",
          );
        }
      };

      if (listaDeLojas.length === 0) {
        fetchLojas();
      } else {
        setListaDeLojas(
          obterEnderecosMaisRecentes(
            localStorage.getItem("lojas")
              ? JSON.parse(localStorage.getItem("lojas") || "")
              : [],
          ),
        );
        setLojaSelecionada(
          localStorage.getItem("lojas")
            ? JSON.parse(localStorage.getItem("lojas") || "")[0].codigo
            : null,
        );
      }
    }
  }, []);

  //todo
  useEffect(() => {
    if (
      (IsEmpty(escolaSelecionada) && matricula) ||
      cpfSearch ||
      nomeCompleto
    ) {
      if (dataUser.length > 0) {
        const firstUser = Array.isArray(dataUser) ? dataUser[0] : dataUser;
        setCdCliente(firstUser?.cdCliente || firstUser?.codigo || 0);
        const bodyConsultaEstudante = {
          numeroMatricula: matricula || matriculaBd || null,
          cdCliente: cdCliente || null,
          cpf: cpfSearch || null,
        };

        consultaEstudanteGratuidade(bodyConsultaEstudante).then(
          function (result) {
            if (IsEmpty(result?.mensagem) && result !== 400 && result !== 500 && result !== 403) {
              const escolaselec = escolas.find(
                (esc) =>
                  esc.value ==
                  String(result[0].codigoEscola).replace(/\s/g, ""),
              );
              setEscolaSelecionada(escolaselec);
            } else if (result === 403) {
              logout();
            }
          },
        );
      }
    }
  }, [dataUser]);

  const handleEscolas = (event: any) => {
    setEscolaSelecionada(event);
  };

  const onClickLimparFiltros = async () => {
    setCpfSearch("");
    setNomeUsuario("");
    setUsuariosPesquisa([]);
    setDataRec("");
    setMatricula("");
    setMatriculaBd("");
    setSolicitarPedido(false);
    setCodigoLojaSelecionada(0);
    setDataUser([]);
    setExistePedido(false);
    setNomeMae("");
    setCpfSearch("");
    setLojaSelecionada(null);
    setGratuidadeCancelada(false);
  };

  const progressGratuidade = () => {
    let ok = 0;
    if (checkForm) ok++;
    if (IsNotEmpty(image)) ok++;
    return ok;
  };

  const handlePedido = () => {
    const usuarioPedido: any[] = [dataUser];
    const bodyPedido: { [key: string]: any } = {
      idCliente: usuarioPedido[0]?.codigo,
      idProduto: 3,
      numeroDocumento: usuarioPedido[0]?.numeroDocumentoAlternativo,
      nrSeqEndereco: codigoLojaSelecionada,
      isAluno: true,
      idTipoMidia: 1,
    };
    finalizarPedidoCartao(bodyPedido);
  };

  const handlePedidoComGratuidade = () => {
    const usuarioPedido: any[] = [dataUser];
    const bodyPedido: { [key: string]: any } = {
      idCliente: usuarioPedido[0]?.codigo,
      idProduto: 3,
      numeroDocumento:
        usuarioPedido[0]?.numeroDocumento ||
        usuarioPedido[0]?.numeroDocumentoAlternativo,
      nrSeqEndereco: codigoLojaSelecionada,
      isAluno: true,
      idTipoMidia: 1,
    };
    finalizarPedidoCartao(bodyPedido).then(function (result) {
      if (result === 200) {
        showPopOver("success", "Cartão", "Socilitado!");
        setExistePedido(true);
      } else if (result === 400 || result === 500 || result === 404) {
        showPopOver("error", "Cartão", "Erro ao solicitar cartão!");
      }
    });
  };

  const handleLojaChange = (e: any) => {
    const selectedValue = e.target.value;

    if (selectedValue !== "") {
      setLojaSelecionada(selectedValue);
      const selectedLoja = listaDeLojas.find(
        (loja) => loja.codigo == selectedValue,
      );
      if (selectedLoja) {
        const nrSeqLoja = selectedLoja.enderecos[0].nrSeqEndereco;
        setCodigoLojaSelecionada(nrSeqLoja);
      }
    }
  };
  useEffect(() => {
    if (listaDeLojas.length > 0) {
      setLojaSelecionada(listaDeLojas[0].codigo);
      const selectedLoja = listaDeLojas.length > 0 ? listaDeLojas[0] : null;
      if (selectedLoja) {
        const nrSeqLoja = selectedLoja.enderecos[0].nrSeqEndereco;
        setCodigoLojaSelecionada(nrSeqLoja);
      }
    }
  }, []);
  const handleFotoBiometrica = () => {
    setAlterarBiometria(true);
  };
  useEffect(() => {
    if (alterarBiometria) {
      setAlterarBiometria(true);
    } else {
      setAlterarBiometria(false);
    }
  }, [alterarBiometria]);

  const escolaNome = () => {
    if (escolaSelecionada) {
      const nomeEscola = Object.values(escolaSelecionada).map((val) => {
        return val;
      }, {});

      return nomeEscola[1];
    } else {
      return "";
    }
  };

  const nextPageMedia = async () => {
    const firstUser = Array.isArray(dataUser) ? dataUser[0] : dataUser;
    setCdCliente(firstUser?.codigo || firstUser?.cdCliente || 0);

    const PODE_CRIAR = canCreateStudant();
    const PODE_ATUALIZAR = hasFullPermission();

    const TIPO_DE_OPERACAO =
      cdCliente === 0 && (!firstUser?.codigo || !firstUser?.cdCliente)
        ? "CRIAR"
        : "ATUALIZAR";
    setLoading(true);
    const isValid = await validateForm();
    if (isValid) {
      let retornoCliente = [];
      const idEscola = Object.values(escolaSelecionada).map((val) => {
        return val;
      }, {});
      //CRIAÇÃO DO CLIENTE====================================================
      if (TIPO_DE_OPERACAO === "CRIAR") {
        cliente.base64Imagem = "";
        cliente.tipoImagem = "IMAGEM_ROSTO";
        cliente.nome = nomeCompleto.trim();
        if (cpfSearch === "" && (matricula !== "" || matriculaBd !== "")) {
          cliente.tipoDocumento = "MATRICULA";
          cliente.numeroDocumento = maskOnlyNumbers(matricula || matriculaBd);
        } else if (cpfSearch !== "") {
          cliente.tipoDocumento = "CPF";
          cliente.numeroDocumento = maskOnlyNumbers(cpfSearch);
          cliente.numeroDocumentoAlternativo = maskOnlyNumbers(
            matricula || matriculaBd,
          );
        } else {
          cliente.tipoDocumento = "CPF";
          cliente.numeroDocumento = maskOnlyNumbers(cpfSearch);
        }

        cliente.dataNascimento = convertData(dataRec);
        cliente.email = email;
        cliente.telefone = maskOnlyNumbers(celular);
        cliente.celular = maskOnlyNumbers(celular);
        cliente.sexo = "";
        cliente.nomeSocial = nomeSocial;
        cliente.senha = "";
        cliente.nomeMae = nomeMae ? nomeMae.trim() : "";
        cliente.confirmacaoSenha = "";
        if (idOperadora) {
          cliente.idOperadora = idOperadora;
        } else {
          cliente.idOperadora = null;
        }
        if (IsNotEmpty(cep)) {
          cliente.cidade = cidade;
          cliente.cep = maskOnlyNumbers(cep);
          cliente.bairro = bairro;
          cliente.logradouro = logradouro;
          cliente.numero = numero;
          cliente.idTipoEndereco = 2;
          cliente.complemento = pontoReferencia;
          cliente.uf = uf;
        } else {
          delete cliente.cidade;
          delete cliente.cep;
          delete cliente.nrSeqEndereco;
          delete cliente.bairro;
          delete cliente.logradouro;
          delete cliente.numero;
          delete cliente.idTipoEndereco;
          delete cliente.complemento;
          delete cliente.uf;
          delete cliente.idTipoLogradouro;
          delete cliente.latitude;
          delete cliente.longitude;
          delete cliente.id;
        }
        cliente.idTiposPerfisCliente = [2];

        //CADASTRO DO PROTOCOLO====================================================
        retornoCliente = PODE_CRIAR
          ? await cadastraCliente(cliente)
          : "NAO_PERMITIDO";
        if (
          retornoCliente.status === 400 ||
          retornoCliente.status === 404 ||
          retornoCliente.status === 403 ||
          retornoCliente.status === 500 ||
          retornoCliente === "NAO_PERMITIDO"
        ) {
          if (retornoCliente === "NAO_PERMITIDO") {
            toast.error("Usuário não tem permissão para cadastrar estudantes");
            return;
          }

          showPopOver(
            "error",
            "Ops...",
            retornoCliente?.response?.data?.errorMessages
              ? retornoCliente?.response?.data?.errorMessages
              : "Erro ao salvar cadastro!",
          );
          setLoading(false);
        } else if (
          (!IsEmpty(retornoCliente) && retornoCliente.status !== 400) ||
          retornoCliente.status !== 404 ||
          retornoCliente.status !== 403 ||
          retornoCliente.status !== 500 ||
          retornoCliente !== "NAO_PERMITIDO"
        ) {
          setCdCliente(retornoCliente?.codigo);

          const bodyConsultaEstudante = {
            numeroMatricula: matricula || matriculaBd || null,
            cdCliente: cdCliente || null,
            cpf: cpfSearch || null,
          };

          const temEstudante = await consultaEstudanteGratuidade(
            bodyConsultaEstudante,
          );

          const [day, month, year] = dataRec.split("/").map(Number);
          const date: Date = new Date(year, month - 1, day); // Mês em JavaScript é baseado em zero, então subtraímos 1
          const isoDateString: string = date.toISOString();
          if (
            !temEstudante[0]?.numeroMatricula &&
            temEstudante !== 400 &&
            temEstudante !== 500 &&
            naoAlterarEstudante === false
          ) {
            salvarEstudanteNaEscola(
              0,
              retornoCliente.codigo || cdCliente,
              maskOnlyNumbers(cpfSearch) || "",
              (cliente.numeroDocumentoAlternativo === "" &&
                cliente.numeroDocumentoAlternativo) ||
              matricula ||
              matriculaBd,
              idEscola[0],
              nomeCompleto.trim().toUpperCase(),
              isoDateString,
              maskOnlyNumbers(celular) || "",
              nomeMae ? nomeMae.trim().toUpperCase() : "",
              email || "",
            );
          } else if (
            temEstudante[0]?.numeroMatricula &&
            temEstudante !== 400 &&
            temEstudante !== 500
          ) {
            alterarEstudanteNaEscola(
              1,
              retornoCliente.codigo || cdCliente,
              maskOnlyNumbers(cpfSearch) || "",
              matricula || matriculaBd,
              idEscola[0],
              nomeCompleto.trim().toUpperCase(),
              isoDateString,
              maskOnlyNumbers(celular) || "",
              nomeMae ? nomeMae.trim().toUpperCase() : "",
              email || "",
            );
          } else if (temEstudante?.mensagem) {
            showPopOver("error", "Estudante", temEstudante?.mensagem);
          }

          setDataUser(retornoCliente);
          showPopOver("success", "Cadastro", "Salvo com sucesso!");
          // cria a gratuidade
          setBiometria(menor12Anos(dataRec));
          setCheckForm(true);

          if (!alterarBiometria) {
            mediaTab.current.click();
            setActiveBullets({
              form: true,
              media: true,
              rules: false,
              askCard: false,
              validation: false,
            });
          } else {
            rulesTab.current.click();
            setActiveBullets({
              form: true,
              media: true,
              rules: true,
              askCard: false,
              validation: false,
            });
          }

          setLoading(false);
        }
      }

      //ALTERAÇÃO DO CLIENTE====================================================
      else if (TIPO_DE_OPERACAO === "ATUALIZAR") {
        const bodyConsultaEstudante = {
          numeroMatricula: matricula || matriculaBd || null,
          cdCliente: cdCliente || null,
          cpf: cpfSearch || null,
        };
        const temEstudante = await consultaEstudanteGratuidade(
          bodyConsultaEstudante,
        );

        const [day, month, year] = dataRec.split("/").map(Number);
        const date: Date = new Date(year, month - 1, day); // Mês em JavaScript é baseado em zero, então subtraímos 1
        const isoDateString: string = date.toISOString();

        cliente.base64Imagem = ""
          ? "".replace("data:image/jpeg;base64,", "")
          : image.replace("data:image/jpeg;base64,", "");

        cliente.tipoImagem = "IMAGEM_ROSTO";
        cliente.nome = nomeCompleto.trim() || nomeUsuario.trimEnd();
        cliente.nomeSocial = nomeSocial;
        cliente.dataNascimento = convertData(dataRec);
        cliente.email = email;
        cliente.id = cdCliente;
        cliente.nomeMae = nomeMae ? nomeMae.trim() : "";
        if (cpfSearch === "" && (matricula !== "" || matriculaBd !== "")) {
          cliente.tipoDocumento = "MATRICULA";
          cliente.numeroDocumento = maskOnlyNumbers(matricula || matriculaBd);
        } else if (cpfSearch !== "") {
          cliente.tipoDocumento = "CPF";
          cliente.numeroDocumento = maskOnlyNumbers(cpfSearch);
          cliente.numeroDocumentoAlternativo = maskOnlyNumbers(
            matricula || matriculaBd,
          );
        } else {
          cliente.tipoDocumento = "CPF";
          cliente.numeroDocumento = maskOnlyNumbers(cpfSearch);
          cliente.numeroDocumentoAlternativo = maskOnlyNumbers(
            matricula || matriculaBd,
          );
        }
        cliente.id = cdCliente;
        cliente.telefone = maskOnlyNumbers(celular);
        cliente.celular = maskOnlyNumbers(celular);
        cliente.sexo = sexo;
        if (IsNotEmpty(cep)) {
          cliente.cidade = cidade;
          cliente.cep = maskOnlyNumbers(cep);
          cliente.nrSeqEndereco = nrSeqEndereco || 0;
          cliente.bairro = bairro;
          cliente.logradouro = logradouro;
          cliente.numero = numero;
          cliente.idTipoEndereco = 2;
          cliente.complemento = pontoReferencia;
          cliente.uf = uf;
        } else {
          delete cliente.cidade;
          delete cliente.cep;
          delete cliente.nrSeqEndereco;
          delete cliente.bairro;
          delete cliente.logradouro;
          delete cliente.numero;
          delete cliente.idTipoEndereco;
          delete cliente.complemento;
          delete cliente.uf;
          delete cliente.idTipoLogradouro;
          delete cliente.latitude;
          delete cliente.longitude;
        }
        if (dataUser) {
          delete cliente.senha;
          delete cliente.confirmacaoSenha;
        }
        cliente.idTiposPerfisCliente = [2];

        if (PODE_ATUALIZAR) {
         alteraClienteAtendimento2(cliente).then(async function (result: any) {
            if (result.status === 200 || result.status < 400) {
              if (
                cliente.base64Imagem !== "" &&
                cliente.base64Imagem !== null
              ) {
                setImage(cliente.base64Imagem);
              }

              dataLogin = await pesquisaCliente({
                email: null,
                nome: nomeUsuario ? nomeUsuario.toUpperCase() : "",
                numeroDocumento:
                  cpfSearch?.replace(/[^\d]+/g, "") ||
                  matricula?.replace(/[^\d]+/g, ""),
                tipoBusca: "TODOS",
                tipoPessoa: "F",
                pagina: 1,
                quantidadePorPaginacao: 10,
              });

              setCdCliente(
                dataLogin[0]?.codigo ||
                dataLogin[0]?.cdCliente ||
                cdCliente ||
                result?.data?.codigo ||
                temEstudante[0]?.cdCliente,
              );

              if (
                cdCliente !== 0 ||
                result?.data?.codigo !== 0 ||
                dataLogin[0]?.codigo !== 0 ||
                dataLogin[0]?.cdCliente !== 0 ||
                temEstudante[0]?.cdCliente !== 0 ||
                temEstudante[0]?.codigo !== 0
              ) {
                if (
                  !temEstudante[0]?.numeroMatricula &&
                  !temEstudante[0]?.dataInclusao
                ) {
                  salvarEstudanteNaEscola(
                    0,
                    result.codigo || cdCliente || temEstudante[0]?.cdCliente,
                    maskOnlyNumbers(cpfSearch) || "",
                    (cliente.numeroDocumentoAlternativo === "" &&
                      cliente.numeroDocumentoAlternativo) ||
                    matricula ||
                    matriculaBd,
                    idEscola[0].trim(),
                    nomeCompleto.trim().toUpperCase(),
                    isoDateString,
                    maskOnlyNumbers(celular) || "",
                    nomeMae ? nomeMae.trim().toUpperCase() : "",
                    email || "",
                  );
                } else {
                  alterarEstudanteNaEscola(
                    1,
                    result.codigo || cdCliente || temEstudante[0]?.cdCliente,
                    maskOnlyNumbers(cpfSearch) || null,
                    matricula || matriculaBd,
                    idEscola[0].trim(),
                    nomeCompleto.trim().toUpperCase(),
                    isoDateString,
                    maskOnlyNumbers(celular) || "",
                    nomeMae ? nomeMae.trim().toUpperCase() : "",
                    email || "",
                  );
                }
              }

              showPopOver(
                "success",
                "Cadastro",
                alterarBiometria ? "Cadastro alterado!" : "Cadastro alterado!",
              );

              setBiometria(menor12Anos(dataRec));
              setCheckForm(true);
              if (!alterarBiometria) {
                mediaTab.current.click();
                setActiveBullets({
                  form: true,
                  media: true,
                  rules: false,
                  askCard: false,
                  validation: false,
                });
              } else {
                rulesTab.current.click();
                setActiveBullets({
                  form: true,
                  media: true,
                  rules: true,
                  askCard: false,
                  validation: false,
                });
              }

              setLoading(false);
            } else {
              setCheckForm(false);
              setActiveBullets({
                form: true,
                media: false,
                rules: false,
                askCard: false,
                validation: false,
              });
              formTab.current.click();
              const data = result?.response?.data;
              const erro =
                data?.errorMessages === undefined ||
                  IsEmpty(data?.errorMessages)
                  ? "Erro ao alterar usuário!"
                  : data?.errorMessages;
              showPopOver(
                "error",
                "Ops...",
                temEstudante?.mensagem
                  ? "Estudante não encontrado com esta matrícula!  " +
                  temEstudante?.mensagem || ""
                  : erro,
              );
              setLoading(false);
              setAlterarBiometria(false);
            }
          });
        } else {
          toast.error("Perfil sem permissão para editar usuário");
          setLoading(false);
          setAlterarBiometria(false);
        }
      }
    }
  };

  const nextPageValidations = async () => {
    setLoading(true);

    cardTab.current.click();
    setActiveBullets({
      form: true,
      media: true,
      rules: true,
      askCard: true,
      validation: false,
    });

    // if (IsNotEmpty(retornoRegras)) {
    //   setTemGratuidade(false); // refresh files e rules
    //   cardTab.current.click();
    //   setActiveBullets({
    //     form: true,
    //     media: true,
    //     rules: true,
    //     askCard: true,
    //     validation: false,
    //   });

    //   //popOver
    //   showPopOver("success", "Regras de Uso", "Salvo com sucesso!");
    // } else {
    //   setActiveBullets({
    //     form: true,
    //     media: true,
    //     rules: true,
    //     askCard: true,
    //     validation: false,
    //   });

    //   //popOver
    //   showPopOver("error", "Regras de Uso", "Erro ao salvar Regras de Uso!");
    // }

    setLoading(false);
  };

  useEffect(() => {
    const verificarGratuidade = async () => {
      setLoading(true);

      try {
        const temGratuidadeEstudante = await consultarGratuidadeEstudante(
          dataUser?.codigo,
        );

        if (
          typeof temGratuidadeEstudante === "object" &&
          [8].includes(temGratuidadeEstudante?.statusGratuidade?.id)
        ) {
          setTemGratuidade(true);
          showPopOver(
            "error",
            "Gratuidade",
            "Estudante está com gratuidade cancelada/rejeitada!",
          );
        }
      } finally {
        setLoading(false);
      }
    };

    if (dataUser?.codigo) {
      verificarGratuidade();
    }
  }, [dataUser]);

  const nextFinallyFree = async () => {
    setLoading(true);
    const codigoUsuario: any[] = [dataUser];

    const bodyConsultaEstudante = {
      numeroMatricula: matricula || matriculaBd || null,
      cdCliente: cdCliente || null,
      cpf: cpfSearch || null,
    };

    consultaEstudanteGratuidade(bodyConsultaEstudante).then(
      async function (result) {
        if (result?.mensagem) {
          showPopOver(
            "error",
            "Ops...",
            result?.mensagem + " Contate o administrador!",
          );
          setLoading(false);
          return;
        }
        if (
          IsEmpty(result?.mensagem) &&
          result !== 400 &&
          result !== 500 &&
          result !== 404
        ) {
          setEmail(result?.email);
          const escolaselec = escolas.find(
            (esc) =>
              esc.value == String(result[0]?.codigoEscola).replace(/\s/g, ""),
          );
          if (
            escolaselec === undefined ||
            escolaselec === null ||
            escolaselec === ""
          ) {
            showPopOver(
              "error",
              "Ops...",
              "Preencha os dados do estudante e salve antes de conceder a gratuidade!",
            );
            setLoading(false);
            setTemGratuidade(false);
            return;
          } else {
            const temgratuidadeEstudante = await consultarGratuidadeEstudante(
              codigoUsuario[0]?.codigo,
            );

            if (
              (typeof temgratuidadeEstudante !== "object" &&
                temgratuidadeEstudante?.id === undefined) ||
              (typeof temgratuidadeEstudante === "object" &&
                temgratuidadeEstudante.statusGratuidade?.id !== 5 &&
                temgratuidadeEstudante.statusGratuidade?.id !== 8 &&
                temgratuidadeEstudante.statusGratuidade?.id !== 6 &&
                temgratuidadeEstudante.statusGratuidade?.id !== 4)
            ) {
              try {
                await handleGetGratuidade(
                  codigoUsuario[0]?.codigo || cdCliente,
                  cpfSearch,
                  3,
                  "Aprovado",
                  "UI-ATENDIMENTO",
                  "post",
                  recoverLoggedUser[0]?.login,
                );
                setTemGratuidade(true);
              } catch (error) {
                console.error(
                  "Erro ao consultar ou atualizar as regras de gratuidade:",
                  error,
                );
                setTemGratuidade(false);
              }

              setTemGratuidade(true);
            } else if (
              typeof temgratuidadeEstudante === "object" &&
              temgratuidadeEstudante.statusGratuidade?.id !== 5 &&
              temgratuidadeEstudante.statusGratuidade?.id !== 8
            ) {
              handleGetGratuidade(
                codigoUsuario[0]?.codigo || cdCliente,
                cpfSearch,
                3,
                "Aprovado",
                "UI-ATENDIMENTO",
                "put",
                recoverLoggedUser[0]?.login,
              );
              setTemGratuidade(true);
              try {
                temStatusGratuidade(codigoUsuario[0]?.codigo);
                await atualizarRegras(idGratuidade, montaList);
              } catch (error) {
                console.error(
                  "Erro ao consultar ou atualizar as regras de gratuidade:",
                  error,
                );
                setTemGratuidade(false);
              }
            } else {
              showPopOver("error", "Gratuidade", "Gratuidade está cancelada!");
            }
            //popOver
            showPopOver("success", "Gratuidade", "Concedida!");
            setTemGratuidade(true);

            if (biometria === false && image === "") {
              setTimeout(() => {
                showPopOver(
                  "error",
                  "Ops...",
                  "O estudante deve solicitar o cartão através do app!",
                );
              }, 6000);
              setLoading(false);
              return;
            } else {
              if (solicitarPedido) handlePedido();
              setLoading(false);
            }
          }
        } else if (result === 403) {
          logout();
        } else {
          showPopOver(
            "error",
            "Ops...",
            "Preencha os dados do estudante e salve antes de conceder a gratuidade!",
          );
          setLoading(false);
          return;
        }
      },
    );
  };

  const validateFormData = (valDate: any) => {
    const erros = [];
    if (valDate === "") {
      erros.push("Data de Nascimento deve ser válida!");
    }

    if (IsEmpty(erros)) {
      return true;
    } else {
      erros.map((e: any) => {
        showPopOver("error", "Ops...", e);
        return false;
      });
    }
  };
  const fetchMoreData = () => {
    if (hasMore) {
      pesquisaEstudante({
        email: "",
        nome: nomeUsuario || "",
        numeroDocumento:
          matricula?.replace(/[^\d]+/g, "") ||
          cpfSearch?.replace(/[^\d]+/g, "") ||
          "",
        tipoBusca: "TODOS",
        tipoPessoa: "F",
        pagina: pagina,
        quantidadePorPaginacao: 10,
      }).then(async (resultado) => {
        if (resultado.length > 0) {
          const cont = pagina + 1;
          setPagina(cont);
          // setPesquisar(false);
          setUsuariosPesquisa((prevItems) => [...prevItems, ...resultado]);
        } else if (resultado.length < 10) {
          //setPesquisar(false);
          setHasMore(false);
        }
      });
    }
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    event.preventDefault(); // Impede o evento de colar
    showPopOver("warning", "Ops...", "Não é possível colar no campo!");
  };

  return (
    <>
      <PopOverAlert
        handleOpenAlert={handleOpenAlert}
        isOpen={isOpen2}
        status={statusPopOver}
        title={titlePopOver}
        subtitle={subtitlePopOver}
      />
      {!showForm ? (
        <Flex
          direction="column"
          minH="100vh"
          pt={{ sm: "125px", lg: "75px" }}
          position="relative"
          mt={"12px"}
        >
          <Flex direction="column" w={{ base: "100%", md: "100%", xl: "100%" }}>
            <Flex
              direction={"row"}
              alignContent={"center"}
              justifySelf={"center"}
            //visibility={viewElements ? "hidden" : "visible"}
            >
              <InputField
                // onPaste={handlePaste}
                isRequired={true}
                ml={"25px"}
                w="200px"
                h="50px"
                id="cpf"
                label="CPF"
                value={cpfSearch}
                onChange={handleChangeMask}
                onKeyDown={handleKeyDown}
              />
              <InputField
                // onPaste={handlePaste}
                isRequired={true}
                ml={"25px"}
                w="200px"
                h="50px"
                id="matricula"
                label="Matrícula"
                value={matricula}
                onChange={handleValorMatricula}
                onKeyDown={handleKeyDown}
              />

              <InputField
                //onPaste={handlePaste}
                isRequired={true}
                ml={"25px"}
                w="350px"
                h="50px"
                id="nome"
                label="Nome"
                value={nomeUsuario}
                onKeyDown={handleKeyDown}
                onChange={(e: {
                  target: { value: React.SetStateAction<string> };
                }) => setNomeUsuario(e.target.value)}
              />

              <IconButton
                mt={"30px"}
                ml={"25px"}
                aria-label="share"
                w="40px"
                h="40px"
                variant="brand"
                borderRadius="20%"
                onClick={onClickPesquisar}
                isLoading={loading}
              >
                <Icon w="14px" h="14px" as={IoSearch} color="white" />
              </IconButton>

              <IconButton
                mt={"30px"}
                ml={"25px"}
                aria-label="share"
                w="40px"
                h="40px"
                variant="brand"
                borderRadius="20%"
                onClick={onClickLimparFiltros}
              >
                <Icon w="14px" h="14px" as={IoCloseCircle} color="white" />
              </IconButton>
            </Flex>
            <Box
              overflowX="hidden"
              // overflowY={usuariosPesquisa.length > 7 ? "scroll" : "hidden"}
              maxW="100vw"
              whiteSpace="nowrap"
              pb="17px"
              visibility={!viewElements ? "visible" : "hidden"}
            >
              <TableContainer
                visibility={usuariosPesquisa.length > 0 ? "visible" : "hidden"}
                width={"100%"}
                alignSelf={"left"}
                borderBottomStartRadius={"12px"}
              >
                <Table variant="striped" colorScheme="gray">
                  <Thead>
                    <Tr>
                      <Th width={"430px"}>Nome</Th>
                      <Th width={"200px"}>Nome mãe</Th>
                      <Th>Documento principal</Th>
                      <Th></Th>
                      <Th></Th>
                    </Tr>
                  </Thead>
                </Table>
              </TableContainer>
            </Box>
            <Flex
              direction="column"
              width={{ xl: "100%", md: "100%", lg: "100%" }}
            >
              <InfiniteScroll
                dataLength={usuariosPesquisa.length}
                next={fetchMoreData}
                hasMore={true}
                loader={
                  <Flex
                    justify="center"
                    px="10px"
                    pt="5px"
                    mb="25px"
                    mt="20px"
                    alignItems={"center"}
                    justifySelf={"center"}
                  >
                    {!hasMore ? (
                      <Text color={"black"} fontSize="lg" fontWeight="300">
                        {usuariosPesquisa.length > 0 &&
                          "Todos os dados carregados"}
                      </Text>
                    ) : (
                      usuariosPesquisa.length > 0 && (
                        <Flex>
                          <Button
                            variant="action"
                            px="24px"
                            fontSize="sm"
                            fontWeight="700"
                            disabled={hasMore ? false : true}
                            onClick={() => fetchMoreData()}
                          >
                            {hasMore
                              ? "Carregar mais dados..."
                              : "Não há mais dados"}
                          </Button>
                        </Flex>
                      )
                    )}
                  </Flex>
                }
              >
                <TableContainer
                  width={"100%"}
                  alignSelf={"left"}
                  borderBottomStartRadius={"12px"}
                  style={{ overflowY: "scroll", maxHeight: "500px" }}
                >
                  <Table variant="striped" colorScheme="gray">
                    <Tbody>
                      {usuariosPesquisa?.map((row, index) => {
                        return (
                          <Tr key={index}>
                            <Td width={"430px"}>{row.nome}</Td>
                            <Td width={"200px"}>{row.nomeMae}</Td>
                            <Td>
                              {" "}
                              {row.numeroMatricula
                                ? row.numeroMatricula
                                : row.tipoDocumento?.codigo === 4
                                  ? row.numeroDocumento
                                  : row.numeroDocumento}
                            </Td>
                            <Td></Td>
                            <Td>
                              {" "}
                              {IsEmpty(row?.dataCancelamento) ? (
                                <Button
                                  variant="action"
                                  px="24px"
                                  fontSize="sm"
                                  fontWeight="700"
                                  onClick={() => confirmarAtendimento(row)}
                                >
                                  Iniciar atendimento{" "}
                                </Button>
                              ) : (
                                <Text
                                  fontSize="sm"
                                  color={"red"}
                                  fontWeight="700"
                                >
                                  Conta cancelada
                                </Text>
                              )}
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </InfiniteScroll>
            </Flex>
          </Flex>
        </Flex>
      ) : null}

      {showForm && (
        <>
          {protocolo || protocoloId ? (
            <Flex
              direction="column"
              visibility={viewElements ? "visible" : "hidden"}
              id="fotoElementoUsuario"
              mt={{
                xl: "-0px",
              }}
              ml={{
                base: "22px",
                md: "-48px",
                xl: "-23px",
              }}
              style={{
                position: "fixed",
                top: "8%",
                left: "57%",
                width: "26%",
                transform: "translate(-50%, -50%)",
                padding: "20px",
                zIndex: 9999,
              }}
            >
              {/* <Text color={textColorPrimary} fontSize={"16px"}>
                Protocolo:
              </Text>
              <Text
                color={textColorPrimary}
                fontSize={"20px"}
                fontWeight={"700"}
              >
                {protocoloId ?? protocolo}
              </Text> */}
            </Flex>
          ) : null}
          <Flex
            direction="column"
            visibility={!IsEmpty(dataUser) ? "visible" : "hidden"}
            id="fotoElementoUsuario2"
            mt={{
              //small: "8px",
              base: "-2px",
              md: "8px",
              xl: "-23px",
            }}
            style={{
              position: "fixed",
              top: "10.22%",
              left: "74%",
              width: "26%",
              transform: "translate(-50%, -50%)",
              padding: "20px",
              zIndex: 9999,
            }}
          >
            {/* <Text color={textColorPrimary} fontSize={"16px"}>
                Protocolo:
              </Text>
              <Text
                color={textColorPrimary}
                fontSize={"20px"}
                fontWeight={"700"}
              >
                {protocoloId ?? protocolo}
              </Text> */}
            {/* {!IsEmpty(dataUser) ? (
              <Profile
                dataUser={dataUser}
                handleFotoIndex={handleFotoIndex}
                cpfBusca={matricula}
                protocolo={protocolo}
              />
            ) : null} */}
          </Flex>
          <Flex
            direction="row"
            pt={{ sm: "125px", lg: "75px" }}
            justifyContent="space-between"
            position="relative"
            mt={"12px"}
          >
            <Button
              variant="darkBrand"
              fontSize="sm"
              borderRadius="16px"
              p="25px"
              leftIcon={<MdYoutubeSearchedFor size="20px" />}
              onClick={() => {
                setDataUser([]);
                setShowForm(false);
                setCpfSearch("");
                cleanFields();
                onClickLimparFiltros();
              }}
            >
              Nova Busca
            </Button>

            <Button
              variant="solid"
              colorScheme="red"
              fontSize="sm"
              borderRadius="16px"
              p="25px"
              disabled={!temGratuidade ? true : false}
              leftIcon={<MdOutlineClear size="20px" />}
              onClick={() => {
                setIsCancelOpen(true);
              }}
            >
              Cancelar gratuidade{" "}
            </Button>
            <Modal
              isOpen={isCancelOpen}
              onClose={() => setIsCancelOpen(false)}
              isCentered
              size={"xl"}
            >
              <ModalOverlay />
              <ModalContent alignSelf={"center"}>
                <ModalHeader>Revogar gratuidade</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <Text>
                    Deseja revogar o benefício da gratuidade de{" "}
                    <b>{nomeUsuario || nomeCompleto} </b>?
                  </Text>
                  <Text
                    color={textColor}
                    fontSize="md"
                    fontWeight="300"
                    display="flex"
                    alignItems="center"
                    mt={1}
                  >
                    A partir deste momento não poderá mais ser utilizado o
                    benefício da gratuidade no transporte.
                  </Text>
                </ModalBody>

                <ModalFooter>
                  <Button
                    variant="solid"
                    colorScheme="red"
                    mr={3}
                    onClick={() => {
                      cancelarGratuidade();
                      setIsCancelOpen(false);
                    }}
                  >
                    Sim
                  </Button>
                  <Button
                    variant="light"
                    mr={3}
                    onClick={() => setIsCancelOpen(false)}
                  >
                    Não
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </Flex>
          <Flex
            // mt={"-170px"}
            direction="column"
            minH="100vh"
            align="center"
            pt={{ sm: "125px", lg: "20px" }}
            position="relative"
          >
            <Image
              src={
                "https://io.billingpay.com.br/bp/img/atendimento/gratuidades/estudanteBanner.png"
              }
              w="100%"
              position="absolute"
              opacity="30%"
              h="45vh"
              objectFit="cover"
              borderRadius="30px"
              me="40px"
              ml="40px"
              mr="30px"
            // mt="160px"
            />

            <Tabs
              variant="unstyled"
              mt={{ base: "60px", md: "0px" }}
              zIndex="0"
              display="flex"
              flexDirection="column"
            >
              <TabList
                display="flex"
                alignItems="center"
                alignSelf="center"
                justifySelf="center"
              >
                <Tab
                  ref={formTab}
                  w={{ sm: "120px", md: "250px", lg: "250px" }}
                  onClick={() => {
                    setActiveBullets({
                      form: true,
                      media: false,
                      rules: false,
                      askCard: false,
                      validation: false,
                    });
                  }}
                >
                  <Flex
                    direction="column"
                    justify="center"
                    align="center"
                    position="relative"
                    _before={{
                      content: "''",
                      width: { sm: "120px", md: "250px", lg: "250px" },
                      height: "3px",
                      bg: activeBullets.media ? "#5340ff" : "#fff",
                      left: { sm: "12px", md: "43px" },
                      top: {
                        sm: activeBullets.form ? "6px" : "4px",
                        md: null,
                      },
                      position: "absolute",
                      bottom: activeBullets.form ? "40px" : "38px",
                      transition: "all .3s ease",
                    }}
                  >
                    <Box
                      zIndex="1"
                      border="2px solid"
                      borderColor="#fff"
                      bg={
                        activeBullets.form
                          ? "linear-gradient(135deg, #fff 0%, #1bd103 100%)"
                          : "linear-gradient(135deg, #eeeeee 0%, #aaaaaa 100%)"
                      }
                      w="16px"
                      h="16px"
                      mb="8px"
                      borderRadius="50%"
                    />
                    <Text
                      color={activeBullets.form ? "black" : "gray.800"}
                      fontWeight={activeBullets.form ? "bold" : "normal"}
                      display={{ sm: "none", md: "block" }}
                    >
                      Cadastro
                    </Text>
                  </Flex>
                </Tab>
                <Tab
                  ref={mediaTab}
                  w={{ sm: "120px", md: "250px", lg: "250px" }}
                  onClick={() => {
                    mediaTab.current.click();
                    setActiveBullets({
                      form: true,
                      media: true,
                      rules: false,
                      askCard: false,
                      validation: false,
                    });
                  }}
                >
                  <Flex
                    direction="column"
                    justify="center"
                    align="center"
                    position="relative"
                    _before={{
                      content: "''",
                      width: { sm: "120px", md: "250px", lg: "250px" },
                      height: "3px",
                      bg: activeBullets.rules ? "#5340ff" : "#fff",
                      left: { sm: "12px", md: "60px" },
                      top: "6px",
                      position: "absolute",
                      bottom: activeBullets.media ? "40px" : "38px",
                      transition: "all .3s ease",
                    }}
                  >
                    <Box
                      zIndex="1"
                      border="2px solid"
                      borderColor="#fff"
                      bg={
                        activeBullets.media
                          ? "linear-gradient(135deg, #fff 0%, #1bd103 100%)"
                          : "linear-gradient(135deg, #eeeeee 0%, #aaaaaa 100%)"
                      }
                      w="16px"
                      h="16px"
                      mb="8px"
                      borderRadius="50%"
                    />
                    <Text
                      color={activeBullets.media ? "black" : "gray.800"}
                      fontWeight={activeBullets.media ? "bold" : "normal"}
                      display={{ sm: "none", md: "block" }}
                    >
                      Biometria facial
                    </Text>
                  </Flex>
                </Tab>
                <Tab
                  ref={rulesTab}
                  w={{ sm: "120px", md: "250px", lg: "250px" }}
                  onClick={() => {
                    rulesTab.current.click();
                    setActiveBullets({
                      form: true,
                      media: true,
                      rules: true,
                      askCard: false,
                      validation: false,
                    });
                  }}
                >
                  <Flex
                    direction="column"
                    justify="center"
                    align="center"
                    position="relative"
                    _before={{
                      content: "''",
                      width: { sm: "120px", md: "250px", lg: "250px" },
                      height: "3px",
                      bg: activeBullets.askCard ? "#5340ff" : "#fff",
                      left: { sm: "12px", md: "55px" },
                      top: "6px",
                      position: "absolute",
                      bottom: activeBullets.rules ? "40px" : "38px",
                      transition: "all .3s ease",
                    }}
                  >
                    <Box
                      zIndex="1"
                      border="2px solid"
                      borderColor="#fff"
                      bg={
                        activeBullets.rules
                          ? "linear-gradient(135deg, #fff 0%, #1bd103 100%)"
                          : "linear-gradient(135deg, #eeeeee 0%, #aaaaaa 100%)"
                      }
                      w="16px"
                      h="16px"
                      mb="8px"
                      borderRadius="50%"
                    />
                    <Text
                      color={activeBullets.rules ? "black" : "gray.800"}
                      fontWeight={activeBullets.rules ? "bold" : "normal"}
                      display={{ sm: "none", md: "block" }}
                    >
                      Regras de Uso
                    </Text>
                  </Flex>
                </Tab>
                <Tab
                  ref={cardTab}
                  w={{ sm: "120px", md: "250px", lg: "250px" }}
                  onClick={() => {
                    setActiveBullets({
                      form: true,
                      media: true,
                      rules: true,
                      askCard: true,
                      validation: false,
                    });
                  }}
                >
                  <Flex
                    direction="column"
                    justify="center"
                    align="center"
                    position="relative"
                    _before={{
                      content: "''",
                      width: { sm: "120px", md: "250px", lg: "250px" },
                      height: "3px",
                      bg: activeBullets.validation ? "#5340ff" : "#fff",
                      left: { sm: "12px", md: "40px" },
                      top: {
                        sm: activeBullets.askCard ? "6px" : "4px",
                        md: null,
                      },
                      position: "absolute",
                      bottom: activeBullets.askCard ? "40px" : "38px",
                      transition: "all .3s ease",
                    }}
                  >
                    <Box
                      zIndex="1"
                      border="2px solid"
                      borderColor="#fff"
                      bg={
                        activeBullets.askCard
                          ? "linear-gradient(135deg, #fff 0%, #1bd103 100%)"
                          : "linear-gradient(135deg, #eeeeee 0%, #aaaaaa 100%)"
                      }
                      w="16px"
                      h="16px"
                      mb="8px"
                      borderRadius="50%"
                    />
                    <Text
                      color={activeBullets.askCard ? "black" : "gray.800"}
                      fontWeight={activeBullets.askCard ? "bold" : "normal"}
                      display={{ sm: "none", md: "block" }}
                    >
                      Pedir cartão
                    </Text>
                  </Flex>
                </Tab>
                <Tab
                  ref={validationTab}
                  w={{ sm: "120px", md: "250px", lg: "250px" }}
                  onClick={() => {
                    validationTab.current.click();
                    setActiveBullets({
                      form: true,
                      media: true,
                      rules: true,
                      askCard: true,
                      validation: true,
                    });
                  }}
                >
                  <Flex
                    direction="column"
                    justify="center"
                    align="center"
                    position="relative"
                  >
                    <Box
                      zIndex="1"
                      border="2px solid"
                      borderColor="#fff"
                      bg={
                        activeBullets.validation
                          ? "linear-gradient(135deg, #fff 0%, #1bd103 100%)"
                          : "linear-gradient(135deg, #eeeeee 0%, #aaaaaa 100%)"
                      }
                      w="16px"
                      h="16px"
                      mb="8px"
                      borderRadius="50%"
                    />
                    <Text
                      color={activeBullets.validation ? "black" : "gray.800"}
                      fontWeight={activeBullets.validation ? "bold" : "normal"}
                      display={{ sm: "none", md: "block" }}
                    >
                      Finalizar
                    </Text>
                  </Flex>
                </Tab>
              </TabList>
              <TabPanels mt="24px" maxW={{ md: "90%", lg: "100%" }} mx="auto">
                <TabPanel
                  w={{ sm: "330px", md: "700px", lg: "850px" }}
                  p="0px"
                  mx="auto"
                >
                  {/* {!IsEmpty(dataUser) ? (
                    <Profile
                      dataUser={dataUser[0]}
                      handleFotoIndex={handleFotoIndex}
                      cpfBusca={cpfSearch}
                    />
                  ) : null} */}
                  <Card p="30px">
                    <Text
                      color={textColor}
                      fontSize="2xl"
                      fontWeight="700"
                      mb="20px"
                    >
                      Dados Pessoais
                    </Text>
                    {erroEstudanteDuplicado && (
                      <Text
                        color={"red.400"}
                        fontSize="md"
                        fontWeight="700"
                        mb="20px"
                      >
                        {erroEstudanteDuplicado}
                      </Text>
                    )}
                    <Flex direction="column" w="100%">
                      <SimpleGrid columns={{ base: 1, md: 2 }} gap="20px">
                        {/* Coluna 1 */}
                        <Stack direction="column" gap="20px">
                          <InputField
                            mb="0px"
                            id="nome"
                            value={formatarNomeCompleto(
                              nomeCompleto.replace(
                                /[^a-zA-ZáàâãäéèêëíìîïóòôõöúùûüçñÁÀÂÃÄÉÈÊËÍÌÎÏÓÒÔÕÖÚÙÛÜÇÑ\s]/g,
                                "",
                              ) ||
                              nomeUsuario.replace(
                                /[^a-zA-ZáàâãäéèêëíìîïóòôõöúùûüçñÁÀÂÃÄÉÈÊËÍÌÎÏÓÒÔÕÖÚÙÛÜÇÑ\s]/g,
                                "",
                              ),
                            )}
                            onChange={(e: any) =>
                              setNomeCompleto(e.target.value)
                            }
                            placeholder="Nome Completo"
                            label="Nome Completo"
                          />

                          <InputField
                            mb="0px"
                            id="cpf"
                            label="CPF"
                            isDisabled={
                              dataCadastroUser &&
                              !usuarios[0]?.perfis.some((perfil: string) =>
                                perfisCadastro.includes(perfil),
                              )
                            }
                            value={
                              cpfSearch !== null ? maskCpfCnpj(cpfSearch) : ""
                            }
                            onChange={handleChangeMask}
                            onKeyDown={handleKeyDown}
                          />

                          <InputField
                            mb="0px"
                            id="nome"
                            value={nomeSocial}
                            onChange={(e: any) => setNomeSocial(e.target.value)}
                            placeholder="Nome Social"
                            label="Nome Social"
                          />

                          <InputField
                            mb="0px"
                            id="email"
                            value={email}
                            disabled={
                              usuarios[0]?.perfis.some((perfil: string) =>
                                perfisDesejadosDataNascimento.includes(perfil),
                              ) || isEmpty(dataUser)
                                ? false
                                : true
                            }
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>,
                            ) => {
                              const value = e.target.value;
                              setEmail(value);
                              cliente.email = value;
                            }}
                            placeholder="Email"
                            label="Email"
                          />
                        </Stack>

                        {/* Coluna 2 */}
                        <Stack direction="column" gap="20px">
                          <InputField
                            mb="0px"
                            id="matricula"
                            value={matricula}
                            placeholder="Matrícula"
                            label="Matrícula"
                            onChange={(e: any) => setMatricula(e.target.value)}
                          />

                          <InputField
                            mb="0px"
                            id="celular"
                            value={celular}
                            maxLength="15"
                            disabled={
                              usuarios[0]?.perfis.some((perfil: string) =>
                                perfisDesejadosDataNascimento.includes(perfil),
                              ) || isEmpty(dataUser)
                                ? false
                                : true
                            }
                            onChange={(e: any) =>
                              setCelular(maskCelular(e.target.value))
                            }
                            placeholder="Celular"
                            label="Celular"
                          />

                            <InputField
                                mb="0px"
                                id="data"
                                label="Data nascimento"
                                value={dataRec}
                                maxLength={10} // Impede digitar mais de 10 caracteres (incluindo as barras)
                                isDisabled={
                                    isEmpty(dataUser) ||
                                    usuarios[0]?.perfis.some((perfil: string) =>
                                        perfisDesejadosDataNascimento.includes(perfil),
                                    )
                                        ? false
                                        : true
                                }
                                onChange={(e: any) => {
                                    const value = e.target.value;
                                    setDataRec(maskDatainfor(value));

                                    // Valida apenas quando a string formatada estiver completa (10 chars: 00/00/0000)
                                    if (value.replace(/\D/g, '').length === 8) {
                                        validateFormData(value);
                                    }
                                }}
                            />

                          <InputField
                            isRequired={true}
                            ml={"25px"}
                            h="50px"
                            id="nomeMae"
                            label="Nome da Mãe"
                            value={nomeMae}
                            onKeyDown={handleKeyDown}
                            onChange={(e: any) => setNomeMae(e.target.value)}
                          />
                        </Stack>
                      </SimpleGrid>
                      {window.config.tenant.includes("Partiu") && (
                        <Flex direction="column" mb="30px" ms="10px">
                          <Text
                            fontSize="sm"
                            fontWeight="700"
                            color={textColor}
                            mb={"10px"}
                            ml={"-10px"}
                          >
                            Operadora
                          </Text>
                          <Select
                            ml={"-10px"}
                            mt={"0px"}
                            required={true}
                            id="operadoras"
                            name="operadoras"
                            height="44px"
                            fontSize="sm"
                            fontWeight="500"
                            borderRadius="16px"
                            defaultValue="0"
                            value={idOperadora ?? null}
                            isDisabled={idOperadora && !IsEmpty(dataUser)}
                            onChange={(e: any) => {
                              setIdOperadora(Number(e.target.value));
                            }}
                          >
                            <option value="0">Selecione a operadora</option>
                            {operadora
                              .filter((item: any) => item?.cliente?.nome)
                              .map((option: any) => (
                                <option key={option.id} value={option.id}>
                                  {option.cliente.nome}
                                </option>
                              ))}
                          </Select>
                        </Flex>
                      )}
                      <Divider mb="20px" mt="25px" />
                      <Text
                        color={textColor}
                        fontSize="2xl"
                        fontWeight="700"
                        mb="20px"
                      >
                        Dados escolares
                      </Text>
                      <SimpleGrid columns={{ base: 1, md: 1 }} gap="20px">
                        <FormLabel
                          mb={"-12px"}
                          ms="10px"
                          htmlFor="grupos"
                          fontSize="sm"
                          color={textColorPrimary}
                          fontWeight="bold"
                          _hover={{ cursor: "pointer" }}
                        >
                          Escola
                        </FormLabel>
                        <AsyncSelect<
                          EscolasOption,
                          true,
                          GroupBase<EscolasOption>
                        >
                          name="escolas"
                          className="selectAsync"
                          options={escolas}
                          value={escolaSelecionada}
                          selectedOptionColor="red"
                          onChange={(e: any) => handleEscolas(e)}
                          placeholder="Digite o nome da escola..."
                          closeMenuOnSelect={true}
                          noOptionsMessage={({ inputValue }) =>
                            !inputValue
                              ? "Sem escola"
                              : "Não foi encontrada nenhuma escola pela busca"
                          }
                          size="md"
                          chakraStyles={{
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              bg: "transparent",
                              p: 0,
                              w: 6,
                              mx: 2,
                              color: "grey",
                              cursor: "inherit",
                            }),
                            indicatorSeparator: () => ({
                              display: "none",
                            }),
                          }}
                          loadOptions={(inputValue, callback) => {
                            const values = escolas.filter((i) =>
                              i.label
                                .toLowerCase()
                                .includes(inputValue.toLowerCase()),
                            );
                            callback(values);
                          }}
                        />
                      </SimpleGrid>

                      {/* <SimpleGrid
                        columns={{ base: 1, md: 2 }}
                        gap="20px"
                        mt={"20px"}
                      >
                        <InputField  onPaste={handlePaste}
                          mb="0px"
                          id="enderecoEscola"
                          value={enderecoEscola}
                          //placeholder="Endereço Escola"
                          label="Endereço"
                          style={{ border: "none", backgroundColor: "white" }}
                          disabled={true}
                        />
                        <InputField  onPaste={handlePaste}
                          mb="0px"
                          id="cidadeEscola"
                          value={cidadeEscola}
                          //placeholder="Endereço Escola"
                          style={{ border: "none", backgroundColor: "white" }}
                          label="Cidade"
                          disabled={true}
                        />
                      </SimpleGrid> */}

                      <Divider mb="20px" mt="25px" />
                      {/* {IsEmpty(dataUser) &&
                      nomeCompleto !== "" &&
                      dataRec !== "" ? (
                        <>
                          <SimpleGrid
                            columns={{ base: 12, md: 1 }}
                            gap="0px"
                            mb="130px"
                          >
                            <Stack direction="column" gap="20px">
                              <Camera
                                tipoGratuidade={1}
                                dataUser={dataCadastroUser || dataUser}
                                handleFoto={handleFoto}
                                cpfBusca={matricula}
                                nomeUser={nomeCompleto}
                                dtNascimento={dataRec}
                                cep={cep}
                              ></Camera>
                            </Stack>
                          </SimpleGrid>
                          <Divider mb="20px" mt="110px" />
                        </>
                      ) : null} */}
                      <Text
                        color={textColor}
                        fontSize="2xl"
                        fontWeight="700"
                        mb="20px"
                      >
                        Endereço
                      </Text>
                      {restricao && (
                        <Text color="red" fontWeight="bold" mb="10px">
                          Cep com restrição de entrega.
                        </Text>
                      )}
                      <SimpleGrid columns={{ base: 1, md: 3 }} gap="20px">
                        <InputField
                          onPaste={handlePaste}
                          isRequired={true}
                          maxLength="10"
                          mb="15px"
                          me="0px"
                          id="cep"
                          label="Cep"
                          value={cep}
                          onChange={(e: { target: { value: any } }) => {
                            if (e.target.value.length === 8) {
                              handleFocusChange(e.target.value);
                            }
                            if (e.target.value.length === 0) {
                              setRestricao(false);
                            }
                            setCep(maskCep(e.target.value));
                          }}
                        />
                      </SimpleGrid>

                      {loadingCep ? (
                        "Carregando..."
                      ) : (
                        <div>
                          {IsNotEmpty(cep) && (
                            <SimpleGrid mt="30px" gap="20px">
                              <InputField
                                onPaste={handlePaste}
                                disabled
                                mb="0px"
                                id="logradouro"
                                value={logradouro}
                                onChange={(e: {
                                  target: {
                                    value: React.SetStateAction<string>;
                                  };
                                }) => setLogradouro(e.target.value)}
                                placeholder="Logradouro"
                                label="Logradouro"
                              />
                            </SimpleGrid>
                          )}
                          {IsNotEmpty(cep) && (
                            <SimpleGrid
                              columns={{ base: 1, md: 2 }}
                              mt="30px"
                              gap="20px"
                            >
                              <Stack direction="column" gap="20px">
                                <InputField
                                  isRequired={true}
                                  mb="20px"
                                  id="numero"
                                  label="Número"
                                  value={numero}
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>,
                                  ) => {
                                    const onlyNumbers = e.target.value.replace(
                                      /\D/g,
                                      "",
                                    );
                                    setNumero(onlyNumbers);
                                  }}
                                />
                                <InputField
                                  onPaste={handlePaste}
                                  mb="0px"
                                  id="cidade"
                                  disabled
                                  value={cidade}
                                  onChange={(e: {
                                    target: {
                                      value: React.SetStateAction<string>;
                                    };
                                  }) => setCidade(e.target.value)}
                                  placeholder="Cidade"
                                  label="Cidade"
                                />
                              </Stack>
                              <Stack direction="column" gap="20px">
                                <InputField
                                  onPaste={handlePaste}
                                  mb="0px"
                                  id="bairro"
                                  disabled
                                  value={bairro}
                                  onChange={(e: {
                                    target: {
                                      value: React.SetStateAction<string>;
                                    };
                                  }) => setBairro(e.target.value)}
                                  placeholder="Bairro"
                                  label="Bairro"
                                />
                                <Flex direction="column">
                                  <FormLabel
                                    ms="10px"
                                    htmlFor="estado"
                                    fontSize="sm"
                                    color={textColorPrimary}
                                    fontWeight="bold"
                                    _hover={{ cursor: "pointer" }}
                                  >
                                    Estado
                                  </FormLabel>
                                  <Select
                                    id="estado"
                                    fontSize="sm"
                                    disabled
                                    value={estado}
                                    variant="main"
                                    h="44px"
                                    maxH="44px"
                                    me="20px"
                                    onChange={(e: {
                                      target: {
                                        value: React.SetStateAction<string>;
                                      };
                                    }) => setEstado(e.target.value)}
                                  >
                                    <option value="">Selecione</option>
                                    {ufSelect.map((option, index) => (
                                      <option value={option.value} key={index}>
                                        {option.label}
                                      </option>
                                    ))}
                                  </Select>
                                </Flex>
                              </Stack>
                            </SimpleGrid>
                          )}
                          {IsNotEmpty(cep) && (
                            <SimpleGrid
                              columns={{ md: 1 }}
                              mt="30px"
                              gap="20px"
                            >
                              <Stack direction="column" gap="20px">
                                <InputField
                                  onPaste={handlePaste}
                                  mb="0px"
                                  id="referencia"
                                  value={pontoReferencia}
                                  onChange={(e: {
                                    target: {
                                      value: React.SetStateAction<string>;
                                    };
                                  }) => setPontoReferencia(e.target.value)}
                                  placeholder="Complemento"
                                  label="Complemento"
                                />
                              </Stack>
                            </SimpleGrid>
                          )}
                        </div>
                      )}
                      <Flex justify="space-between" mt="24px">
                        <Button
                          variant="brand"
                          fontSize="sm"
                          borderRadius="16px"
                          p="25px"
                          ms="auto"
                          rightIcon={<MdOutlineDoubleArrow size="20px" />}
                          isLoading={loading}
                          disabled={erroEstudanteDuplicado != "" ? true : false}
                          loadingText="Salvando..."
                          onClick={() => {
                            nextPageMedia();
                            setAlterarBiometria(false);
                          }}
                        >
                          {IsEmpty(dataCadastroUser)
                            ? "Salvar cadastro "
                            : "Alterar cadastro"}
                        </Button>
                      </Flex>
                    </Flex>
                  </Card>
                </TabPanel>
                <TabPanel
                  w={{ sm: "330px", md: "700px", lg: "850px" }}
                  p="0px"
                  mx="auto"
                >
                  <Card p="30px" h={"500px"}>
                    <Text
                      color={textColor}
                      fontSize="2xl"
                      fontWeight="700"
                      mb="20px"
                    >
                      Foto biométrica
                    </Text>

                    {algumUsuarioCompativel ? (
                      <>
                        <Flex direction="column" w="100%">
                          <Stack direction="column" gap="20px">
                            <Camera
                              tipoGratuidade={1}
                              dataUser={dataUser}
                              handleFoto={handleFoto}
                              cpfBusca={cpfSearch || matricula}
                              nomeUser={nomeCompleto}
                              dtNascimento={dataRec}
                              cep={cep}
                              tipoDocumento={cpfSearch ? "CPF" : "MATRICULA"}
                            ></Camera>
                          </Stack>
                        </Flex>

                        <Flex justify="end" mt="224px">
                          <Button
                            variant="light"
                            fontSize="sm"
                            borderRadius="16px"
                            isLoading={loading}
                            loadingText="Salvando..."
                            disabled={!image ? true : false}
                            w={{ base: "128px", md: "148px" }}
                            h="46px"
                            rightIcon={
                              <MdOutlineDoubleArrow
                                size="20px"
                              //style={{ rotate: "180deg" }}
                              />
                            }
                            onClick={() => {
                              handleFotoBiometrica();
                              nextPageMedia();
                            }}
                          >
                            Salvar foto
                          </Button>
                        </Flex>
                      </>
                    ) : (
                      <>
                        <Flex
                          direction="column"
                          w="100%"
                          justifyContent={"center"}
                          align={"center"}
                        >
                          <Text
                            color={"red.300"}
                            fontSize="2xl"
                            mt={"70px"}
                            fontWeight="700"
                            mb="20px"
                          >
                            Perfil não autorizado a tirar foto biométrica!
                          </Text>
                        </Flex>
                        <Flex justify="end" mt="184px">
                          <Button
                            variant="light"
                            fontSize="sm"
                            borderRadius="16px"
                            w={{ base: "128px", md: "148px" }}
                            h="46px"
                            rightIcon={
                              <MdOutlineDoubleArrow
                                size="20px"
                              //style={{ rotate: "180deg" }}
                              />
                            }
                            onClick={() => {
                              rulesTab.current.click();
                              setActiveBullets({
                                form: true,
                                media: true,
                                rules: true,
                                askCard: false,
                                validation: false,
                              });
                            }}
                          >
                            Próximo
                          </Button>
                        </Flex>
                      </>
                    )}
                  </Card>
                </TabPanel>
                <TabPanel
                  w={{ sm: "330px", md: "700px", lg: "850px" }}
                  p="0px"
                  mx="auto"
                >
                  <Card p="30px">
                    <Text
                      color={textColor}
                      fontSize="2xl"
                      fontWeight="700"
                      mb="20px"
                    >
                      Regras de uso
                    </Text>

                    <Flex direction="column" w="100%">
                      <Stack direction="row" gap="5px" mt="-10px">
                        <InputField
                          onPaste={handlePaste}
                          mr="20px"
                          id="qtdUsoMensal"
                          maxLength="3"
                          placeholder="Quantidade"
                          label="Qtd. Uso Mensal"
                          value={76}
                          disabled
                          style={{ border: "none", backgroundColor: "white" }} // Estilos diretamente no componente
                        />
                        <Checkbox
                          mr="30px"
                          colorScheme="brandScheme"
                          //checked={biometria}
                          isChecked={
                            biometria || menor12Anos(dataRec) ? true : false
                          }
                          onChange={(e: any) => setBiometria(e.target.checked)}
                        />
                        <Text
                          color={textColor}
                          fontSize="sm"
                          fontWeight="700"
                          display="flex"
                          alignItems="center"
                        >
                          Desativar Biometria Facial
                        </Text>
                      </Stack>
                      <Flex justify="space-between" mt="24px">
                        <Button
                          variant="light"
                          fontSize="sm"
                          borderRadius="16px"
                          w={{ base: "128px", md: "148px" }}
                          h="46px"
                          leftIcon={
                            <MdOutlineDoubleArrow
                              size="20px"
                              style={{ rotate: "180deg" }}
                            />
                          }
                          onClick={() => mediaTab.current.click()}
                        >
                          Anterior
                        </Button>
                        {checkForm && (
                          <Button
                            variant="brand"
                            fontSize="sm"
                            borderRadius="16px"
                            p="25px"
                            rightIcon={<MdOutlineDoubleArrow size="20px" />}
                            isLoading={loading}
                            loadingText="Salvando..."
                            onClick={() => nextPageValidations()}
                          >
                            Salvar regras de uso
                          </Button>
                        )}
                      </Flex>
                    </Flex>
                  </Card>
                </TabPanel>
                <TabPanel
                  w={{ sm: "330px", md: "700px", lg: "850px" }}
                  p="0px"
                  mx="auto"
                >
                  <Card p="30px">
                    <Grid
                      flexDirection="column"
                      pt={{ base: "30px", md: "80px", xl: "0px" }}
                    >
                      <Flex direction="column" w="100%">
                        <Text
                          color={textColor}
                          fontSize="2xl"
                          fontWeight="700"
                          mb="20px"
                        >
                          Pedir cartão
                        </Text>
                      </Flex>
                      {
                        existePedido === true ? (
                          <Flex direction="column" w="100%" align={"center"}>
                            <Text
                              color={textColor}
                              fontSize="2X1"
                              fontWeight="700"
                            >
                              Usuário já possui pedido de cartão!
                            </Text>
                          </Flex>
                        ) : algumUsuarioCompativel &&
                          tipoPedidoCartao !== "PODE SOLICITAR SEGUNDA_VIA" &&
                          tipoPedidoCartao !== "2 VIA SOLICITADA" ? (
                          <Card p="30px">
                            <Flex alignItems="center" mb="20px">
                              <Text
                                color={textColorSecondary}
                                fontSize="md"
                                fontWeight="700"
                              >
                                Onde deseja receber seu cartão?{" "}
                              </Text>
                            </Flex>

                            <Flex justify="flex-start">
                              <RadioGroup
                                onChange={(e: any) => setOndeReceber(e)}
                                defaultValue={"loja"}
                                defaultChecked={true}
                                value={ondeReceber}
                              >
                                <Flex justify="space-around">
                                  <div style={{ marginRight: 20 }}>
                                    <Radio value="loja">Retirada na loja</Radio>

                                    <Icon
                                      ml={"10px"}
                                      as={MdStore}
                                      color={iconColor}
                                      w="24px"
                                      h="24px"
                                    />
                                  </div>
                                </Flex>
                              </RadioGroup>
                            </Flex>
                            {ondeReceber === "loja" && (
                              <>
                                <div>
                                  <Text
                                    fontSize="sm"
                                    fontWeight="300"
                                    color={textColor}
                                    mt={"20px"}
                                  >
                                    Lista de lojas:
                                  </Text>
                                </div>

                                <Select
                                  required={true}
                                  id="lojas"
                                  name="lojasApi"
                                  height="44px"
                                  fontSize="sm"
                                  fontWeight="500"
                                  borderRadius="16px"
                                  defaultValue=""
                                  value={lojaSelecionada}
                                  onChange={(e: any) => handleLojaChange(e)}
                                >
                                  <option value="">Selecione a loja</option>
                                  {listaDeLojas
                                    .filter((item) => item.codigo !== 733)
                                    .map((option) => (
                                      <option
                                        key={option.codigo}
                                        value={option.codigo}
                                      >
                                        {option.nome}
                                      </option>
                                    ))}
                                </Select>
                                {lojaSelecionada != "733" && (
                                  <div style={{ marginTop: 20 }}>
                                    <Text
                                      fontSize="sm"
                                      fontWeight="600"
                                      color={textColor}
                                      mt={"20px"}
                                    >
                                      Endereço da loja:
                                    </Text>

                                    {listaDeLojas != null &&
                                      lojaSelecionada !== null &&
                                      listaDeLojas.filter(
                                        (loja) =>
                                          loja.codigo == lojaSelecionada,
                                      )[0]?.enderecos[0]?.logradouro +
                                      " , " +
                                      listaDeLojas.filter(
                                        (loja) =>
                                          loja.codigo == lojaSelecionada,
                                      )[0]?.enderecos[0]?.numero +
                                      " - " +
                                      listaDeLojas.filter(
                                        (loja) =>
                                          loja.codigo == lojaSelecionada,
                                      )[0]?.enderecos[0]?.complemento}
                                  </div>
                                )}
                              </>
                            )}
                            <div>
                              <Text
                                fontSize="sm"
                                fontWeight="300"
                                color={textColor}
                                mt={"20px"}
                              >
                                {ondeReceber === "loja"
                                  ? "A retirada do cartão na loja não possui taxa de entrega e o prazo de entrega é de até 10 dias úteis."
                                  : "A entrega do cartão no endereço possui taxa de entrega de " +
                                  formatCurrencyFloor(14.0) +
                                  " e o prazo de recebimento é de até 15 dias úteis, após o pagamento do boleto."}
                              </Text>
                            </div>
                            {existePedido === false &&
                              temGratuidade === true && (
                                <Flex justify="end" mt="84px">
                                  {(image && lojaSelecionada) ||
                                    (lojaSelecionada &&
                                      biometria === false) ? null : (
                                    <Text
                                      fontSize="sm"
                                      fontWeight="600"
                                      color={"red"}
                                      mt={"20px"}
                                    >
                                      O cartão só poderá ser solicitado caso a
                                      foto estiver cadastrada!
                                    </Text>
                                  )}
                                  <Button
                                    variant="light"
                                    fontSize="sm"
                                    mt={"10px"}
                                    isDisabled={
                                      (image && lojaSelecionada) ||
                                        (lojaSelecionada && biometria === false)
                                        ? false
                                        : true
                                    }
                                    colorScheme="green"
                                    borderRadius="16px"
                                    w={{ base: "128px", md: "148px" }}
                                    h="46px"
                                    onClick={() => {
                                      validationTab.current.click();
                                      handlePedidoComGratuidade();
                                    }}
                                  >
                                    Solicitar cartão{" "}
                                  </Button>
                                </Flex>
                              )}
                          </Card>
                        ) : (
                          <>
                            <Flex direction="column" w="100%" align={"center"}>
                              {tipoPedidoCartao !==
                                "PODE SOLICITAR SEGUNDA_VIA" &&
                                tipoPedidoCartao !== "2 VIA SOLICITADA" ? (
                                <Text
                                  color={"green.300"}
                                  fontSize="2xl"
                                  fontWeight="700"
                                  mb="20px"
                                >
                                  O aluno deve entrar em contato com a Central
                                  de Atendimento Jaé, através do 0800 2121 828,
                                  para agendar o comparecimento no posto para
                                  captura de foto. O cartão será entregue na
                                  escola: {escolaNome()}
                                  {/* {escolaselecionada.values} */}
                                </Text>
                              ) : (
                                <Text
                                  color={textColor}
                                  fontSize="2X1"
                                  fontWeight="700"
                                >
                                  Gratuidade não permite solicitar 2º via,
                                  solicite pelo menu Cliente!
                                </Text>
                              )}
                            </Flex>
                          </>
                        )
                        // (
                        //   <Flex direction="column" w="100%" align={"center"}>
                        //     <Text
                        //       color={textColor}
                        //       fontSize="2X1"
                        //       fontWeight="700"
                        //     >
                        //       Usuário já possui pedido de cartão!
                        //     </Text>
                        //   </Flex>
                        // )
                      }

                      <Flex justify="end" mt="15px">
                        <Button
                          variant="light"
                          fontSize="sm"
                          borderRadius="16px"
                          w={{ base: "128px", md: "148px" }}
                          h="46px"
                          rightIcon={
                            <MdOutlineDoubleArrow
                              size="20px"
                            //style={{ rotate: "180deg" }}
                            />
                          }
                          onClick={() => {
                            validationTab.current.click();
                            setSolicitarPedido(true);
                            setActiveBullets({
                              form: true,
                              media: true,
                              rules: true,
                              askCard: true,
                              validation: true,
                            });
                          }}
                        >
                          Próximo
                        </Button>
                      </Flex>
                    </Grid>
                  </Card>
                </TabPanel>
                <TabPanel
                  w={{ sm: "330px", md: "700px", lg: "850px" }}
                  p="0px"
                  mx="auto"
                >
                  <Card p="30px">
                    <Grid
                      flexDirection="column"
                      pt={{ base: "30px", md: "80px", xl: "0px" }}
                    >
                      <Flex direction="column" w="100%">
                        <Text
                          color={textColor}
                          fontSize="2xl"
                          fontWeight="700"
                          mb="20px"
                        >
                          Validações
                        </Text>
                        <Flex alignItems="center" mb="20px">
                          <Text
                            color={textColorSecondary}
                            fontSize="md"
                            fontWeight="700"
                          >
                            {progressGratuidade()}/2 FINALIZADO&nbsp;&nbsp;
                            <Icon
                              ms="auto"
                              as={MdFlag}
                              color={
                                progressGratuidade() === 2 ? "green.500" : "red"
                              }
                              h="18px"
                              w="18px"
                            />
                          </Text>
                        </Flex>
                        <SimpleGrid
                          columns={5}
                          gap="5px"
                          alignItems="center"
                          mb="20px"
                        >
                          <Flex
                            bg={checkForm ? "green.500" : bgBar}
                            h="8px"
                            borderRadius="36px"
                          />
                          <Flex
                            bg={IsNotEmpty(image) ? "green.500" : bgBar}
                            h="8px"
                            borderRadius="36px"
                          />
                        </SimpleGrid>
                        <Flex mb="15px" align="center">
                          <Box w="30px" me="12px">
                            <CircProgressMini
                              step="1"
                              percentage={checkForm ? 100 : 0}
                            />
                          </Box>
                          <Text
                            color={checkForm ? textColorTertiary : "red.500"}
                            fontWeight="500"
                            fontSize="md"
                            me="5px"
                          >
                            Informações Cadastrais
                          </Text>
                          {checkForm && (
                            <Icon
                              as={MdCheck}
                              h="18px"
                              w="18px"
                              color={"green.500"}
                            />
                          )}
                        </Flex>
                        {/* {errosList.map((e: any) => (
                          <Flex
                            mb="5px"
                            ml="38px"
                            me="12px"
                            flexDirection="row"
                            alignItems="center"
                            fontSize="md"
                            color={textColorSecondary}
                            fontWeight="300"
                          >
                            <Icon
                              as={MdClear}
                              h="18px"
                              w="18px"
                              mr="5px"
                              color={"red.500"}
                            />{" "}
                            {e}
                          </Flex>
                        ))} */}
                        <Flex mt="10px" mb="25px" align="center">
                          <Box w="30px" me="12px">
                            <CircProgressMini
                              step="2"
                              percentage={IsNotEmpty(image) ? 100 : 0}
                            />
                          </Box>
                          <Text
                            color={
                              IsNotEmpty(image) ? textColorTertiary : "red.500"
                            }
                            fontWeight="500"
                            fontSize="md"
                            me="5px"
                          >
                            Biometria facial
                          </Text>

                          {IsNotEmpty(image) && (
                            <Icon
                              as={MdCheck}
                              h="18px"
                              w="18px"
                              color={"green.500"}
                            />
                          )}
                        </Flex>
                      </Flex>
                      {(IsNotEmpty(historicoStatus) || checkForm) && (
                        <OrderStatus
                          ms={{ base: "0px", lg: "20px" }}
                          mt={{ base: "0px", lg: "0px" }}
                          zIndex="0"
                          p="0 20px"
                          gridArea={{
                            base: "2 / 1 / 3 / 3",
                            lg: "1 / 2 / 2 / 3",
                          }}
                          statusData={historicoStatus}
                          dataCadastro={dataCadastroUser}
                        />
                      )}
                    </Grid>
                    <Divider mb="20px" mt="25px" />
                    <Flex direction="column" w="100%" color={textColorTertiary}>
                      <Flex mt="24px" justify="space-between">
                        <Button
                          variant="light"
                          fontSize="sm"
                          borderRadius="16px"
                          p="25px"
                          leftIcon={
                            <MdOutlineDoubleArrow
                              size="20px"
                              style={{ rotate: "180deg" }}
                            />
                          }
                          onClick={() => cardTab.current.click()}
                        >
                          Anterior
                        </Button>

                        {hasFullPermission() && (
                          <Button
                            variant="solid"
                            colorScheme="green"
                            fontSize="sm"
                            borderRadius="16px"
                            isLoading={loading}
                            loadingText="Aguarde..."
                            disabled={
                              !isAbleToGiveGratuidade() ||
                              temGratuidade === true ||
                              loading
                            }
                            onClick={() => nextFinallyFree()}
                            leftIcon={<MdOutlineEngineering size="20px" />}
                            p="25px"
                          >
                            Conceder gratuidade
                          </Button>
                        )}
                      </Flex>
                    </Flex>
                    <Divider mb="20px" mt="25px" />
                    <Flex direction="column" w="100%" color={textColorTertiary}>
                      {/* <HistoricoTickets
                        dataUser={dataUser[0]}
                        ticketUserNovo={ticketGerado}
                      /> */}
                      <TextField
                        id="observacaoChamado"
                        label="Observação do chamado"
                        h="100px"
                        w="100%"
                        maxLength="150"
                        placeholder="Digite detalhes sobre o atendimento do chamado. Max 150 caracteres"
                        value={observacaoChamado}
                        onChange={(e: {
                          target: { value: React.SetStateAction<string> };
                        }) => setObservacaoChamado(e.target.value)}
                      />
                      <Flex
                        direction="column"
                        w="100%"
                        color={textColorTertiary}
                        alignItems={"flex-end"}
                      >
                        <Button
                          ml={"240px"}
                          w={"263px"}
                          colorScheme="brand"
                          mr={1}
                          onClick={() => finalizarAtendimento()}
                          isLoading={loading}
                        //disabled={observacaoChamado === "" ? true : false}
                        >
                          Finalizar atendimento
                        </Button>
                      </Flex>
                    </Flex>
                  </Card>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Flex>
        </>
      )}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          alignSelf={"center"}
          bgColor={!IsEmpty(dataUser) ? "white" : "green.600"}
          w={"630px"}
        >
          <ModalHeader>
            {!IsEmpty(dataUser) ? (
              <Text fontSize="xl" color={"black"} fontWeight="bold">
                Deseja iniciar atendimento?
              </Text>
            ) : (
              <Text fontSize="xl" color={"white"} fontWeight="bold">
                Deseja iniciar o cadastro a este novo estudante?
              </Text>
            )}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {!IsEmpty(dataUser) ? (
              <Flex direction={"column"}>
                {cpfSearch ? (
                  <Text fontSize="xl" color={"black"}>
                    <b>Cpf:</b> {maskCpfCnpj(cpfSearch)}
                  </Text>
                ) : null}
                {matricula ? (
                  <Text fontSize="xl" color={"black"}>
                    <b>Matrícula:</b> {matricula}
                  </Text>
                ) : null}

                <Text fontSize="xl" color={"black"}>
                  <b>Nome:</b> {nomeUsuario}
                </Text>
              </Flex>
            ) : (
              <Flex direction={"column"}>
                {cpfSearch ? (
                  <Text fontSize="xl" color={"white"}>
                    <b>Cpf:</b> {cpfSearch}
                  </Text>
                ) : null}

                {matricula ? (
                  <Text fontSize="xl" color={"white"}>
                    <b>Matrícula:</b> {matricula}
                  </Text>
                ) : null}

                {nomeUsuario ? (
                  <Text fontSize="xl" color={"white"}>
                    <b>Nome:</b> {nomeUsuario}
                  </Text>
                ) : null}
              </Flex>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="brand"
              mr={3}
              onClick={() => confirmarAtendimento(null)}
            >
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={modalData} onClose={onChangeModalDataClose} size={"sm"}>
        <ModalOverlay />
        <ModalContent alignSelf={"center"}>
          <ModalHeader>Escolha a data</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex justify="flex-start" h={"332px"} w={"623px"}>
              <DateRangePicker
                className="rdrDefinedRangesWrapper "
                onChange={handleSelect}
                moveRangeOnFirstSelection={false}
                months={1}
                showMonthAndYearPickers={false}
                ranges={[selectedDateRange]}
                displayMode="date"
                direction="horizontal"
                locale={pt}
                //singleDatePicker={true}
                dragSelectionEnabled={false}
                showDateDisplay={false}
                headerContent={false}
                scroll={{ enabled: false }}
                showPreview={false}
                dateDisplayFormat="dd MMM, yyyy"
                editableDateInputs={false}
                staticRanges={[]}
                inputRanges={[]}
              />
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              leftIcon={<MdSearch />}
              colorScheme="brand"
              mr={3}
              onClick={() => {
                onChangeModalDataClose();
              }}
            >
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          alignSelf={"center"}
          bgColor={!IsEmpty(dataUser) ? "white" : "green.600"}
          w={"630px"}
        >
          <ModalHeader>
            {!IsEmpty(dataUser) ? (
              <Text fontSize="xl" color={"black"} fontWeight="bold">
                Deseja iniciar atendimento?
              </Text>
            ) : (
              <Text fontSize="xl" color={"white"} fontWeight="bold">
                Deseja iniciar o cadastro a este novo cliente?
              </Text>
            )}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {!IsEmpty(dataUser) ? (
              <Flex direction={"column"}>
                {cpfSearch ? (
                  <Text fontSize="xl" color={"black"}>
                    <b>Cpf:</b> {maskCpfCnpj(cpfSearch)}
                  </Text>
                ) : null}
                {matricula ? (
                  <Text fontSize="xl" color={"black"}>
                    <b>Matrícula:</b> {matricula}
                  </Text>
                ) : null}
                <Text fontSize="xl" color={"black"}>
                  <b>Nome:</b> {nomeUsuario}
                </Text>
              </Flex>
            ) : (
              <Flex direction={"column"}>
                {cpfSearch ? (
                  <Text fontSize="xl" color={"white"}>
                    <b>Cpf:</b> {cpfSearch}
                  </Text>
                ) : null}

                {matricula ? (
                  <Text fontSize="xl" color={"white"}>
                    <b>Matrícula:</b> {matricula}
                  </Text>
                ) : null}
              </Flex>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="brand"
              mr={3}
              onClick={() => confirmarAtendimento(null)}
            >
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

